/* DDI "Find your light" quiz - MVP (PROFIT-WEB-20260903-01 / F-20260903-07)
 * Mobile-first (390px) image-click quiz + persona result.
 *
 * Contract with the theme:
 *   sections/ddi-quiz.liquid renders
 *     <div class="ddi-quiz" data-ddi-quiz data-ab-root="<exp id>"></div>
 *     <script type="application/json" data-ddi-quiz-config>{ products, images, ab, settings }</script>
 *   This file owns the QUESTION + PERSONA spec so the storefront and the offline
 *   preview harness render byte-identically. Copy room replaces the strings in SPEC.
 *
 * Events (dataLayer + gtag + Meta Pixel trackCustom + Shopify Customer Events as
 * ddi_<name>, all guarded), field names per the
 * v2 strategy QUIZ_BUNDLE_STRATEGY_20260903.md:
 *   quiz_start{entry_point,variant}
 *   quiz_step{step,question,question_text,answer,answer_text,variant}
 *   quiz_complete{persona,budget_band,style,space,outcome,colour,variant}
 *   quiz_email_capture{persona,variant,incentive}
 *   quiz_result_click{sku,handle,bundle,position,persona,role,variant}
 *   quiz_atc{sku,bundle,persona,variant,value,currency}
 *
 * Bundles (F-20261006-62): each persona's result offers its own Simple Bundles
 * products (SPEC.bundles), one line item at the bundle price. Live price, compare-at
 * and stock come from /products/<handle>.js at result time. A bundle that is not
 * published (404) or not available is left out; if NONE resolve, the result falls
 * back to the old two-item pair block unchanged.
 *
 * Round 9 (F-20261020-17, BF sandbox): the result leads with SETS. The pool is the whole matching problem
 * tab from the homepage Black Friday bundles section (SPEC.tabBundles, Quick Buy and Bundle & Save alike),
 * not a mix of every persona the answers touched, so every set shown fixes the problem picked. Sets list
 * dearest first with a product's finishes side by side; the matched lamp and two picks follow them.
 * A bundle with an on-white cover (theme asset bf-cover-<handle>.jpg) shows it.
 *
 * A/B: never edits the head-slot bucketing script. Reads window._DDI_AB[<exp id>]
 * (or the html.exp-<id>-<variant> class) and varies ONLY entry placement,
 * incentive copy and question order. Control renders untouched; every variant keeps
 * identical layout boxes so CLS stays 0.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- spec */
  /* Final copy from the Copy room, WEB-COPY-20260903-01 (F-20260903-28).
     Wording changes come back through Copy - do not edit strings here. */
  /* round 9: theme asset folder, read off this script's own URL, for the bundle covers */
  var ASSET_BASE = (function () {
    var s = document.currentScript;
    if (!s || !/[/]ddi-quiz[.]js/.test(s.src || '')) s = document.querySelector('script[src*="/ddi-quiz.js"]');
    var u = s && s.src ? String(s.src) : '';
    return u.indexOf('/ddi-quiz.js') > -1 ? u.split('/ddi-quiz.js')[0] + '/' : '';
  })();

  var SPEC = {
    version: 'quiz-v1',

    screens: [
      {
        key: 'space',
        question: 'Where is the light going?',
        sub: 'Start with the room you keep looking at.',
        /* tone = placeholder tile until Creative supplies room photography;
           override any option with the section's "Option tile images" setting. */
        options: [
          { v: 'bedside', label: 'Bedside',        sub: 'Last light of the night',  product: 'puffball-lamp-snow-white' },
          { v: 'living',  label: 'Living room',    sub: 'Sofa, sideboard, floor',   product: 'volley-lamp-clay' },
          { v: 'desk',    label: 'Desk or studio', sub: 'Work, read, make',         product: 'hoist-lamp-brushed-metal' },
          { v: 'dining',  label: 'Dining or bar',  sub: 'Table, island, top shelf', product: 'boxy-lamp' },
          { v: 'gift',    label: "It's a gift",    sub: 'Not for my place',         product: 'ribbon-lamp-blood-orange' }
        ]
      },
      {
        key: 'outcome',
        question: 'What do you want it to do?',
        sub: 'This answer does most of the work.',
        /* product = the archetype lamp for that outcome; its photo is the tile */
        options: [
          { v: 'winddown', label: 'Wind me down',    sub: 'Soft, low, end of day',    product: 'puffball-lamp-snow-white' },
          { v: 'focus',    label: 'Help me focus',   sub: 'Light where you point it', product: 'metal-touch-lamp' },
          { v: 'mood',     label: 'Set the mood',    sub: 'A glow across the room',   product: 'puffball-lamp' },
          { v: 'statement',label: 'Be the statement',sub: 'People ask about it',      product: 'bigger-is-better-lamp' }
        ]
      },
      {
        key: 'style',
        question: 'Which room feels like yours?',
        sub: 'Closest is close enough.',
        options: [
          /* v stays 'japandi' for routing; the LABEL does not say Japandi - the word is
             an SEO category only and this tile shows a Volley, which is an Original. */
          { v: 'warmmin',  label: 'Warm minimal',    sub: 'Calm, few things, warm', product: 'boxy-lamp' },
          { v: 'japandi',  label: 'Paper and timber',sub: 'Quiet and natural',      product: 'volley-lamp-clay' },
          { v: 'midcent',  label: 'Mid-century',     sub: 'Brass, walnut, curves',  product: 'hoist-lamp-brushed-metal' },
          { v: 'playful',  label: 'Playful',         sub: 'Colour on purpose',      product: 'bubblegum-lamp-citrus' }
        ]
      },
      {
        key: 'colour',
        question: 'Which finish do you like?',
        sub: 'We will match the colourway to it.',
        options: [
          { v: 'neutral', label: 'Neutral', sub: 'White, clay, warm dirt',  product: 'puffball-lamp-snow-white' },
          { v: 'warm',    label: 'Warm',    sub: 'Burnt and blood orange',  product: 'sunnyboy-lamp-burnt' },
          { v: 'green',   label: 'Green',   sub: 'Grass and forest',        product: 'volley-lamp-grass' },
          { v: 'metal',   label: 'Metal',   sub: 'Brass and aluminium',     product: 'metal-touch-lamp' }
        ]
      }
      /* F-20261013-29: the 'budget' screen ("What are you happy to spend?") is gone, Theo's
         call 13 Oct. Sets now list dearest first, so nobody is asked for a price. */
    ],

    /* The 8 seed personas named in the v2 strategy (QUIZ_BUNDLE_STRATEGY_20260903.md):
       Wind-Down, Nest, Symmetrist, Focus, Host, Statement, Original, Gifter.
       Each is seeded from a MEASURED pair. `colour` swaps the colourway inside the
       recommended family, `budget`
       swaps the hero between the value and premium lamp in the same persona.
       Every handle was checked in stock on the live store on 3 Sep 2026. */
    personas: {
      winddown: {
        name: 'The Wind-Down',
        blurb: 'You want the room to drop a gear after dark. Low, warm light for the end of the day.',
        hero: 'puffball-lamp-snow-white',
        colour: { warm: 'puffball-lamp', metal: 'metal-touch-lamp' },
        budget: { premium: 'volley-lamp-clay', open: 'volley-lamp-clay' },
        pair: { label: 'Soft Glow pair', items: ['puffball-lamp-snow-white', 'boxy-lamp'] }
      },
      nest: {
        name: 'The Nest',
        blurb: 'Warm colour, softly lit. One lamp is all it takes to make a room feel lived in.',
        hero: 'puffball-lamp',
        colour: { neutral: 'puffball-lamp-snow-white', green: 'ribbon-lamp' },
        budget: {},
        /* AN+Puffball is the measured pair (62 orders) but AN is out of stock;
           Ribbon Blood Orange is the in-stock stand-in until Inventory restocks. */
        pair: { label: 'Nest pair', items: ['puffball-lamp', 'ribbon-lamp-blood-orange'] }
      },
      symmetrist: {
        name: 'The Symmetrist',
        blurb: 'One each side, matching. Nothing makes a room look finished faster than a pair.',
        hero: 'metal-touch-lamp',
        colour: {},
        budget: {},
        /* Portable Metal Touch x2 is DDI's single biggest bundle: 183 orders, A$34,615. */
        pair: { label: 'Bedside Twins', items: ['metal-touch-lamp', 'metal-touch-lamp'] }
      },
      focus: {
        /* named for the Workshop pair it recommends (Hoist + Trunk) */
        name: 'The Workbench',
        blurb: 'Light you point at the job. Made to be used, and good enough to leave out.',
        hero: 'metal-touch-lamp',
        colour: { warm: 'hoist-lamp-faded-denim' },
        budget: { premium: 'hoist-lamp-brushed-metal', open: 'hoist-lamp-brushed-metal' },
        pair: { label: 'Workshop pair', items: ['hoist-lamp-brushed-metal', 'trunk-lamp-grass'] }
      },
      host: {
        name: 'The Host',
        blurb: 'A low lamp and somewhere to drop your keys. That is the whole table trick.',
        hero: 'boxy-lamp',
        colour: { warm: 'puffball-lamp', neutral: 'puffball-lamp-snow-white' },
        budget: {},
        /* Billy Dish + Plaza Tray: 36 orders / A$14.4k with no bundle offered. */
        pair: { label: 'Table Kit', items: ['billy-dish-tall', 'the-plaza-tray-medium'] }
      },
      statement: {
        name: 'The Statement',
        blurb: 'Colour on purpose. Switch it on and it is the first thing anyone asks about.',
        hero: 'bubblegum-lamp-citrus',
        colour: { warm: 'bubblegum-lamp', neutral: 'boxy-lamp' },
        budget: { premium: 'bigger-is-better-lamp' },
        pair: { label: 'Citrus Duo', items: ['bubblegum-lamp-citrus', 'bubblegum-lamp'] }
      },
      original: {
        /* "designed in Melbourne" is permitted here and ONLY here: every handle this
           persona can resolve to is one of the four Originals (Volley, Sunnyboy, Hoist).
           If a non-Original is ever added to this persona, cut that phrase first. */
        name: 'The Original',
        blurb: 'Our own lamps, designed in Melbourne. Heavier in the hand, quieter in a room, built to last.',
        hero: 'volley-lamp-clay',
        colour: { green: 'volley-lamp-grass', warm: 'sunnyboy-lamp-burnt', metal: 'hoist-lamp-brushed-metal' },
        budget: {},
        /* New demand, not measured: Originals barely co-purchase today, stock is deep. */
        pair: { label: 'Sun & Court pair', items: ['volley-lamp-clay', 'sunnyboy-lamp-dirt'] }
      },
      gifter: {
        name: 'The Safe Bet',
        blurb: 'Good enough to hand over without explaining. Hard to get wrong, easy to wrap.',
        hero: 'metal-touch-lamp',
        colour: { warm: 'puffball-lamp', neutral: 'puffball-lamp-snow-white' },
        budget: {},
        /* Billy Dish + PMT: 33 orders / A$12.6k with no bundle offered. */
        pair: { label: 'Desk & Dish', items: ['metal-touch-lamp', 'billy-dish-tall'] }
      }
    },

    email: {
      headline: 'Want this sent to you?',
      body: 'We will send your match and the pair, so you can think it over.',
      placeholder: 'you@example.com',
      cta: 'Send me my match',
      skip: 'Skip, show me now',
      /* NEW KEY - needs one line of render in renderEmail(), under the input.
         We are taking an email address and (once the list subscribe is wired)
         starting marketing contact, so the screen has to say what happens.
         Style it like .ddi-quiz__pairnote (14px, muted). */
      consent: 'One email with your result. Unsubscribe any time.'
    },

    result: {
      eyebrow: 'Your match',
      heroTitle: 'Start here',
      pairTitle: 'Better as a pair',
      /* Deliberately NOT "bought together most often": true of the measured pairs
         (PMT x2, ATC+AN) but false of the new Originals pairs, and an untrue
         social-proof line is an ACCC problem. */
      pairNote: 'Two pieces we would put in the same room. They add separately, so what is in stock is what ships.',
      /* Pair total block. {saving} is replaced with the dollar amount at render.
         Copy room owns this wording - do not edit it here. */
      totalLabel: 'Pair total',
      totalSave: 'You save {saving} on the pair',
      restart: 'Start again',
      /* F-20261006-62 bundle block. Placeholder wording until Copy replaces it. */
      bundleTitle: 'Made as a set',
      bundleNote: 'Adds to your cart as one item, at the set price.',
      bundleTotalLabel: 'Set price',
      bundleTotalSave: 'You save {saving} on the set',
      bundleOtherTitle: 'More sets for your room',
      bundleShipsLate: 'Ships late October',
      /* F-20261013-63: Theo 14 Oct - 3 lamp picks, every matching set, a way to browse the rest.
         No cap on sets ("show every matching set"); minSets is the floor below which the
         result is topped up from SPEC.related. */
      picksTitle: 'Two more lamps for you',
      /* round 9: the lamp block now follows the sets. Placeholder wording until Copy replaces it. */
      lampTitle: 'Or start with one lamp',
      minSets: 8,
      browseAll: 'Browse all bundles',
      browseAllUrl: 'collections/bundles'
    },

    /* F-20261013-63: nearest personas first, used to top up lamp picks and sets. Order is
       "same space answer first, then same style" (bedside: winddown/symmetrist, dining: host,
       gift: gifter, workspace: focus; style is no longer asked). Every key lists all 7 others. */
    /* F-20261013-63: which personas each answer points at (+1 per hit). Every persona with a
       non-zero score contributes ALL its in-stock sets, highest score first. Colour is kept
       narrow on purpose: warm and neutral fit almost every persona, so they score nothing. */
    answerPersonas: {
      space:   { bedside: ['winddown', 'symmetrist'], living: ['nest', 'statement', 'original'],
                 desk: ['focus'], dining: ['host'], gift: ['gifter'] },
      outcome: { winddown: ['winddown'], focus: ['focus'], mood: ['nest'], statement: ['statement'] },
      colour:  { green: ['original'], metal: ['focus'] }
    },

    related: {
      winddown:   ['nest', 'symmetrist', 'gifter', 'statement', 'host', 'focus', 'original'],
      nest:       ['winddown', 'statement', 'host', 'gifter', 'symmetrist', 'original', 'focus'],
      symmetrist: ['winddown', 'gifter', 'focus', 'nest', 'original', 'host', 'statement'],
      focus:      ['symmetrist', 'gifter', 'original', 'winddown', 'host', 'nest', 'statement'],
      host:       ['nest', 'gifter', 'winddown', 'statement', 'focus', 'original', 'symmetrist'],
      statement:  ['nest', 'original', 'gifter', 'winddown', 'host', 'symmetrist', 'focus'],
      original:   ['statement', 'focus', 'gifter', 'symmetrist', 'winddown', 'nest', 'host'],
      gifter:     ['winddown', 'host', 'nest', 'symmetrist', 'statement', 'original', 'focus']
    },

    /* F-20261006-62: the 33 quiz bundles Theo signed off 30 Sep (F-20260924-59,
       THEO_SIGNOFF_20260930.md). One list per persona, every bundle unique to it.
       band = budget band 1 under $200, 2 $200-350, 3 $350-500, 4 $500+ (the budget
       answer picks the featured one). vid = the bundle's one variant; img = the
       first item's handle, used for the photo until the bundle has its own.
       Prices are NOT here - they are read live from the product. */
    bundleBands: { value: 1, mid: 2, premium: 3, open: 4 },
    bundles: {
      winddown: [
        { h: "tea-low-light-bundle", sku: "QB-WIND-1", vid: 54535616594238, band: 1, img: "timber-mushie-lamp-beech-small",
          items: "Timber Mushie Lamp (Beech / Small) + Spill the Tea Cup and Saucer (Egg Yolk)" },
        { h: "snow-white-bedside-bundle", sku: "QB-WIND-2", vid: 54535616627006, band: 2, img: "puffball-lamp-snow-white",
          items: "Puffball Lamp (Snow White) + Perfect Cup (White) + Billy Dish (Short)" },
        { h: "boxy-evening-set-bundle", sku: "QB-WIND-3", vid: 54535616659774, band: 3, img: "boxy-lamp",
          items: "Boxy Lamp + Puffball Lamp (Snow White) + Spill the Tea Cup and Saucer (Egg Yolk)" },
        { h: "the-whole-evening-bundle", sku: "QB-WIND-4", vid: 54535616692542, band: 4, img: "volley-lamp-clay",
          items: "Volley Lamp (Clay) + Boxy Lamp + Puffball Lamp (Snow White) + Perfect Cup (White)" }
      ],
      nest: [
        { h: "butter-glow-bundle-ships-late-oct", sku: "QB-NEST-1", vid: 54535616725310, band: 1, img: "absolutely-necessary-lamp-1",
          items: "Absolutely Necessary Lamp + Perfect Cup (Butter)" },
        { h: "blood-orange-nest-bundle", sku: "QB-NEST-2", vid: 54535616758078, band: 2, img: "puffball-lamp",
          items: "Puffball Lamp (Blood Orange) + Ribbon Lamp (Blood Orange)" },
        { h: "cloud-clubroom-bundle-ships-late-oct", sku: "QB-NEST-3", vid: 54535616790846, band: 3, img: "puffball-lamp",
          items: "Puffball Lamp (Blood Orange) + Above the Clouds Lamp + Clubroom Tray (Roundish)" },
        { h: "the-full-nest-bundle-ships-late-oct", sku: "QB-NEST-4", vid: 54535616823614, band: 4, img: "above-the-clouds-lamp",
          items: "Above the Clouds Lamp + Absolutely Necessary Lamp + Puffball Lamp (Blood Orange) + Billy Dish (Tall) + Fine Ribbed Glass + Spill the Tea Cup and Saucer (Red and Blue)" }
      ],
      symmetrist: [
        { h: "mushie-twins-bundle", sku: "QB-SYMM-1", vid: 54535616856382, band: 1, img: "timber-mushie-lamp-beech-small",
          items: "2 x Timber Mushie Lamp (Beech / Small)" },
        { h: "aluminium-twins-dishes-bundle-ships-late-oct", sku: "QB-SYMM-2", vid: 54535616889150, band: 2, img: "portable-metal-touch-lamp-aluminium",
          items: "2 x Portable Metal Touch Lamp (Aluminium) + 2 x Billy Dish (Short)" },
        { h: "cloud-twins-dishes-bundle-ships-late-oct", sku: "QB-SYMM-3", vid: 54535616921918, band: 3, img: "above-the-clouds-lamp",
          items: "2 x Above the Clouds Lamp + 2 x Billy Dish (Short)" },
        { h: "hoist-twins-dishes-bundle", sku: "QB-SYMM-4", vid: 54535616954686, band: 4, img: "hoist-lamp-brushed-metal",
          items: "2 x Hoist Lamp (Brushed Metal) + 2 x Billy Dish Snr." }
      ],
      focus: [
        { h: "desk-glass-bundle-ships-late-oct", sku: "QB-WORK-1", vid: 54535616987454, band: 1, img: "portable-metal-touch-lamp-aluminium",
          items: "Portable Metal Touch Lamp (Aluminium) + Fine Ribbed Glass" },
        { h: "denim-desk-bundle", sku: "QB-WORK-2", vid: 54535617020222, band: 2, img: "hoist-lamp-faded-denim",
          items: "Hoist Lamp (Faded Denim) + Billy Dish (Tall)" },
        { h: "two-hoist-studio-bundle", sku: "QB-WORK-3", vid: 54535617052990, band: 3, img: "hoist-lamp-brushed-metal",
          items: "Hoist Lamp (Brushed Metal) + Hoist Lamp (Faded Denim)" },
        { h: "the-full-studio-bundle-ships-late-oct", sku: "QB-WORK-4", vid: 54535617085758, band: 4, img: "hoist-lamp-brushed-metal",
          items: "Hoist Lamp (Brushed Metal) + Hoist Lamp (Faded Denim) + Portable Metal Touch Lamp (Aluminium) + Fine Ribbed Glass" }
      ],
      host: [
        { h: "the-table-kit-bundle", sku: "QB-HOST-1", vid: 54535617118526, band: 1, img: "billy-dish-short",
          items: "Billy Dish (Short) + Billy Dish (Tall) + The Plaza Tray (Medium)" },
        { h: "lamp-tray-dish-bundle-ships-late-oct", sku: "QB-HOST-2", vid: 54535617151294, band: 2, img: "absolutely-necessary-lamp-1",
          items: "Absolutely Necessary Lamp + The Plaza Tray (Medium) + Billy Dish (Tall)" },
        { h: "table-kit-full-set-bundle", sku: "QB-HOST-3", vid: 54535617184062, band: 2, img: "billy-dish-short",
          items: "Billy Dish (Short) + Billy Dish (Tall) + Billy Dish Snr. + The Plaza Tray (Small) + The Plaza Tray (Medium) + The Plaza Tray (Large)" },
        { h: "boxy-dinner-party-bundle-ships-late-oct", sku: "QB-HOST-4", vid: 54535617216830, band: 3, img: "boxy-lamp",
          items: "Boxy Lamp + Clubroom Tray (Roundish) + Butta Dish + Fine Ribbed Glass" },
        { h: "the-whole-table-bundle-ships-late-oct", sku: "QB-HOST-5", vid: 54535617249598, band: 4, img: "boxy-lamp",
          items: "Boxy Lamp + Absolutely Necessary Lamp + Billy Dish (Short) + Billy Dish (Tall) + Billy Dish Snr. + The Plaza Tray (Small) + The Plaza Tray (Medium) + The Plaza Tray (Large)" }
      ],
      statement: [
        { h: "siren-pair-bundle-ships-late-oct", sku: "QB-STAT-1", vid: 54535617282366, band: 2, img: "siren-lamp",
          items: "Siren Lamp (Blood Orange) + Siren Lamp (Forest Green)" },
        { h: "bubblegum-pair-bundle", sku: "QB-STAT-2", vid: 54535617315134, band: 2, img: "bubblegum-lamp-citrus",
          items: "Bubblegum Lamp (Citrus) + Bubblegum Lamp (Mint)" },
        { h: "statement-accent-bundle", sku: "QB-STAT-3", vid: 54535617347902, band: 3, img: "bigger-is-better-lamp",
          items: "Bigger Is Better Lamp + Puffball Lamp (Blood Orange)" },
        { h: "colour-riot-bundle", sku: "QB-STAT-4", vid: 54535617380670, band: 4, img: "bigger-is-better-lamp",
          items: "Bigger Is Better Lamp + Bubblegum Lamp (Citrus) + Spill the Tea Cup and Saucer (Red and Blue) + Fine Ribbed Glass" }
      ],
      original: [
        { h: "sunnyboy-dish-bundle", sku: "QB-ORIG-1", vid: 54535617413438, band: 2, img: "sunnyboy-lamp-burnt",
          items: "Sunnyboy Lamp (Burnt) + Billy Dish Snr." },
        { h: "sun-court-bundle", sku: "QB-ORIG-2", vid: 54535617446206, band: 3, img: "volley-lamp-clay",
          items: "Volley Lamp (Clay) + Sunnyboy Lamp (Dirt)" },
        { h: "hoist-sunnyboy-bundle", sku: "QB-ORIG-3", vid: 54535617478974, band: 3, img: "hoist-lamp-brushed-metal",
          items: "Hoist Lamp (Brushed Metal) + Sunnyboy Lamp (Dirt)" },
        { h: "the-originals-trio-bundle", sku: "QB-ORIG-4", vid: 54535617511742, band: 4, img: "volley-lamp-clay",
          items: "Volley Lamp (Clay) + Sunnyboy Lamp (Dirt) + Trunk Lamp (Dirt)" }
      ],
      gifter: [
        { h: "desk-dish-bundle-ships-late-oct", sku: "QB-GIFT-1", vid: 54535617544510, band: 1, img: "portable-metal-touch-lamp-aluminium",
          items: "Portable Metal Touch Lamp (Aluminium) + Billy Dish (Tall)" },
        { h: "puffball-tea-bundle", sku: "QB-GIFT-2", vid: 54535618003262, band: 2, img: "puffball-lamp",
          items: "Puffball Lamp (Blood Orange) + Spill the Tea Cup and Saucer (Egg Yolk)" },
        { h: "housewarming-bundle-ships-late-oct", sku: "QB-GIFT-3", vid: 54535618036030, band: 3, img: "above-the-clouds-lamp",
          items: "Above the Clouds Lamp + Puffball Lamp (Blood Orange) + Butta Dish" },
        { h: "the-big-gift-bundle-ships-late-oct", sku: "QB-GIFT-4", vid: 54535618068798, band: 4, img: "above-the-clouds-lamp",
          items: "Above the Clouds Lamp + Absolutely Necessary Lamp + Portable Metal Touch Lamp (Aluminium) + Butta Dish + Fine Ribbed Glass + Billy Dish (Tall) + Spill the Tea Cup and Saucer (Egg Yolk)" }
      ]
    },

    /* F-20261013-29: with the budget question gone, symmetrist and original can only be
       reached by ?persona= deep link, so Theo asked (13 Oct) for their 8 sets to be added
       to the answers people do reach. Handles only - the defs stay in their own list. */
    bundleExtras: {
      winddown:  ['mushie-twins-bundle', 'cloud-twins-dishes-bundle-ships-late-oct'],
      focus:     ['aluminium-twins-dishes-bundle-ships-late-oct', 'hoist-twins-dishes-bundle', 'hoist-sunnyboy-bundle'],
      statement: ['sunnyboy-dish-bundle', 'sun-court-bundle', 'the-originals-trio-bundle']
    },

    /* Round 9: the homepage Black Friday bundles, one list per problem tab, in the homepage order
       (a product's finishes side by side). Generated by bf_round9/build_round9.py - edit the homepage
       section's lists, then rebuild. vid guards the handle; fam keeps finishes together. */
    personaTab: {"winddown": "winddown", "nest": "nest", "symmetrist": "winddown", "focus": "focus", "host": "host", "statement": "statement", "original": "statement", "gifter": "gifter"},
    tabBundles: {
      winddown: [
        {"h": "boxy-puffball-blood-orange-lamp-bundle", "sku": "LBBPBOLBAU", "vid": 51434990338366, "fam": "boxy-puffball-blood-orange-lamp-bundle+boxy-puffball-snow-white-lamp-bundle", "cover": true, "items": "Boxy Lamp + Puffball Lamp (Blood Orange)"},
        {"h": "boxy-puffball-snow-white-lamp-bundle", "sku": "LBBPSWLBAU", "vid": 51435244814654, "fam": "boxy-puffball-blood-orange-lamp-bundle+boxy-puffball-snow-white-lamp-bundle", "cover": true, "items": "Puffball Lamp (Snow White) + Boxy Lamp"},
        {"h": "cloud-twins-dishes-bundle-ships-late-oct", "sku": "QB-SYMM-3", "vid": 54535616921918, "fam": "cloud-twins-dishes-bundle-ships-late-oct", "cover": true, "items": "2 x Above the Clouds Lamp + 2 x Billy Dish (Short)"},
        {"h": "the-whole-evening-bundle", "sku": "QB-WIND-4", "vid": 54535616692542, "fam": "the-whole-evening-bundle", "cover": true, "items": "Volley Lamp (Clay) + Boxy Lamp + Puffball Lamp (Snow White) + Perfect Cup (White)"},
        {"h": "snow-white-bedside-bundle", "sku": "QB-WIND-2", "vid": 54535616627006, "fam": "snow-white-bedside-bundle", "cover": true, "items": "Puffball Lamp (Snow White) + Perfect Cup (White) + Billy Dish (Short)"},
        {"h": "boxy-evening-set-bundle", "sku": "QB-WIND-3", "vid": 54535616659774, "fam": "boxy-evening-set-bundle", "cover": true, "items": "Boxy Lamp + Puffball Lamp (Snow White) + Spill the Tea Cup and Saucer (Egg Yolk)"},
        {"h": "mushie-twins-bundle", "sku": "QB-SYMM-1", "vid": 54535616856382, "fam": "mushie-twins-bundle+mushie-lamp-duo-small-regular-beech+mushie-lamp-duo-small-regular-walnut", "cover": true, "items": "2 x Timber Mushie Lamp (Beech / Small)"},
        {"h": "mushie-lamp-duo-small-regular-beech", "sku": "LBMLDSRBAU", "vid": 51434487185726, "fam": "mushie-twins-bundle+mushie-lamp-duo-small-regular-beech+mushie-lamp-duo-small-regular-walnut", "cover": true, "items": "Timber Mushie Lamp (Beech / Regular) + Timber Mushie Lamp (Beech / Small)"},
        {"h": "mushie-lamp-duo-small-regular-walnut", "sku": "LBMLDSRWAU", "vid": 51434430693694, "fam": "mushie-twins-bundle+mushie-lamp-duo-small-regular-beech+mushie-lamp-duo-small-regular-walnut", "cover": true, "items": "Timber Mushie Lamp (Walnut / Regular) + Timber Mushie Lamp (Walnut / Small)"},
        {"h": "minimalist-lighting-glassware-bundle", "sku": "LHBMLGBAU", "vid": 50294674587966, "fam": "minimalist-lighting-glassware-bundle", "cover": true, "items": "Puffball Lamp (Snow White) + Perfect Cup (Butter) + Perfect Cup (White)"},
        {"h": "tea-low-light-bundle", "sku": "QB-WIND-1", "vid": 54535616594238, "fam": "tea-low-light-bundle", "cover": true, "items": "Timber Mushie Lamp (Beech / Small) + Spill the Tea Cup and Saucer (Egg Yolk)"},
        {"h": "leafy-ribbon-lamp-spill-the-tea-bundle", "sku": "LHBLRLSTTBAU", "vid": 51435253530942, "fam": "leafy-ribbon-lamp-spill-the-tea-bundle+toasted-ribbon-lamp-spill-the-tea-bundle", "cover": true, "items": "Ribbon Lamp (Forest Green) + Spill the Tea Cup and Saucer (Linen and Olive)"},
        {"h": "toasted-ribbon-lamp-spill-the-tea-bundle", "sku": "LHBTRLSTTBAU", "vid": 51435247370558, "fam": "leafy-ribbon-lamp-spill-the-tea-bundle+toasted-ribbon-lamp-spill-the-tea-bundle", "cover": true, "items": "Ribbon Lamp (Blood Orange) + Spill the Tea Cup and Saucer (Coffee and Cream)"},
        {"h": "bedside-lamp-duo", "sku": "ribbon-siren-bundle", "vid": 47965058302270, "fam": "bedside-lamp-duo", "cover": true, "items": "Choose 2: Ribbon Lamp or Siren Lamp, your colours"},
        {"h": "cosy-lamp-tray-duo", "sku": "LHBCLTDAU", "vid": 50294639067454, "fam": "cosy-lamp-tray-duo", "cover": true, "items": "Timber Mushie Lamp (Walnut / Regular) + Clubroom Tray (Oval)"}
      ],
      nest: [
        {"h": "the-full-nest-bundle-ships-late-oct", "sku": "QB-NEST-4", "vid": 54535616823614, "fam": "the-full-nest-bundle-ships-late-oct", "cover": true, "items": "Above the Clouds Lamp + Absolutely Necessary Lamp + Puffball Lamp (Blood Orange) + Billy Dish (Tall) + Fine Ribbed Glass + Spill the Tea Cup and Saucer (Red and Blue)"},
        {"h": "puffball-absolutely-necessary-lamp-bundle-blood-orange", "sku": "BUNDLE-PUFFBALL-ABSOLUTELY-ORANGE-AU-PLUG", "vid": 50157601456446, "fam": "puffball-absolutely-necessary-lamp-bundle-blood-orange+puffball-absolutely-necessary-lamp-bundle-snow-white", "cover": true, "items": "Puffball Lamp (Blood Orange) + Absolutely Necessary Lamp"},
        {"h": "puffball-absolutely-necessary-lamp-bundle-snow-white", "sku": "BUNDLE-PUFFBALL-ABSOLUTELY-WHITE-AU-PLUG", "vid": 50157621707070, "fam": "puffball-absolutely-necessary-lamp-bundle-blood-orange+puffball-absolutely-necessary-lamp-bundle-snow-white", "cover": true, "items": "Puffball Lamp (Snow White) + Absolutely Necessary Lamp"},
        {"h": "cloud-clubroom-bundle-ships-late-oct", "sku": "QB-NEST-3", "vid": 54535616790846, "fam": "cloud-clubroom-bundle-ships-late-oct", "cover": true, "items": "Puffball Lamp (Blood Orange) + Above the Clouds Lamp + Clubroom Tray (Roundish)"},
        {"h": "above-the-clouds-puffball-lamp-bundle-blood-orange-1", "sku": "BUNDLE-ABOVE-PUFFBALL-ORANGE-AU-PLUG", "vid": 50157695041854, "fam": "above-the-clouds-puffball-lamp-bundle-blood-orange-1+above-the-clouds-puffball-lamp-bundle-snow-white", "cover": true, "items": "Above the Clouds Lamp + Puffball Lamp (Blood Orange)"},
        {"h": "above-the-clouds-puffball-lamp-bundle-snow-white", "sku": "BUNDLE-ABOVE-PUFFBALL-WHITE-AU-PLUG", "vid": 50157592314174, "fam": "above-the-clouds-puffball-lamp-bundle-blood-orange-1+above-the-clouds-puffball-lamp-bundle-snow-white", "cover": true, "items": "Puffball Lamp (Snow White) + Above the Clouds Lamp"},
        {"h": "blood-orange-nest-bundle", "sku": "QB-NEST-2", "vid": 54535616758078, "fam": "blood-orange-nest-bundle", "cover": true, "items": "Puffball Lamp (Blood Orange) + Ribbon Lamp (Blood Orange)"},
        {"h": "above-the-clouds-absolutely-necessary-lamp", "sku": "BATCABSAU", "vid": 47330443395390, "fam": "above-the-clouds-absolutely-necessary-lamp", "cover": true, "items": "Above the Clouds Lamp + Absolutely Necessary Lamp"},
        {"h": "boxy-lamp-absolutely-necessary-lamp", "sku": "BUNDLE-BOXY-ABSOLUTELY", "vid": 47330559754558, "fam": "boxy-lamp-absolutely-necessary-lamp", "cover": true, "items": "Boxy Lamp + Absolutely Necessary Lamp"},
        {"h": "butter-glow-bundle-ships-late-oct", "sku": "QB-NEST-1", "vid": 54535616725310, "fam": "butter-glow-bundle-ships-late-oct", "cover": true, "items": "Absolutely Necessary Lamp + Perfect Cup (Butter)"}
      ],
      focus: [
        {"h": "the-full-studio-bundle-ships-late-oct", "sku": "QB-WORK-4", "vid": 54535617085758, "fam": "the-full-studio-bundle-ships-late-oct", "cover": true, "items": "Hoist Lamp (Brushed Metal) + Hoist Lamp (Faded Denim) + Portable Metal Touch Lamp (Aluminium) + Fine Ribbed Glass"},
        {"h": "two-hoist-studio-bundle", "sku": "QB-WORK-3", "vid": 54535617052990, "fam": "two-hoist-studio-bundle", "cover": true, "items": "Hoist Lamp (Brushed Metal) + Hoist Lamp (Faded Denim)"},
        {"h": "hoist-sunnyboy-bundle", "sku": "QB-ORIG-3", "vid": 54535617478974, "fam": "hoist-sunnyboy-bundle", "cover": true, "items": "Hoist Lamp (Brushed Metal) + Sunnyboy Lamp (Dirt)"},
        {"h": "aluminium-twins-dishes-bundle-ships-late-oct", "sku": "QB-SYMM-2", "vid": 54535616889150, "fam": "aluminium-twins-dishes-bundle-ships-late-oct", "cover": true, "items": "2 x Portable Metal Touch Lamp (Aluminium) + 2 x Billy Dish (Short)"},
        {"h": "denim-desk-bundle", "sku": "QB-WORK-2", "vid": 54535617020222, "fam": "denim-desk-bundle", "cover": true, "items": "Hoist Lamp (Faded Denim) + Billy Dish (Tall)"},
        {"h": "desk-glass-bundle-ships-late-oct", "sku": "QB-WORK-1", "vid": 54535616987454, "fam": "desk-glass-bundle-ships-late-oct", "cover": true, "items": "Portable Metal Touch Lamp (Aluminium) + Fine Ribbed Glass"},
        {"h": "aluminium-lamp-duo", "sku": "LBALDAU", "vid": 50294644638014, "fam": "aluminium-lamp-duo+brassy-gold-lamp-duo", "cover": true, "items": "2 x Portable Metal Touch Lamp (Aluminium)"},
        {"h": "brassy-gold-lamp-duo", "sku": "LBBGLDAU", "vid": 50294640836926, "fam": "aluminium-lamp-duo+brassy-gold-lamp-duo", "cover": true, "items": "2 x Portable Metal Touch Lamp (Brassy Gold)"},
        {"h": "hoist-twins-dishes-bundle", "sku": "QB-SYMM-4", "vid": 54535616954686, "fam": "hoist-twins-dishes-bundle", "cover": true, "items": "2 x Hoist Lamp (Brushed Metal) + 2 x Billy Dish Snr."}
      ],
      statement: [
        {"h": "statement-accent-bundle", "sku": "QB-STAT-3", "vid": 54535617347902, "fam": "statement-accent-bundle", "cover": true, "items": "Bigger Is Better Lamp + Puffball Lamp (Blood Orange)"},
        {"h": "studio-trio-rice-paper-lamp-bundle", "sku": "LBSTRPLBAU", "vid": 51434593190206, "fam": "studio-trio-rice-paper-lamp-bundle", "cover": true, "items": "Bigger Is Better Lamp + Above the Clouds Lamp + Absolutely Necessary Lamp"},
        {"h": "citrus-lamp-duo", "sku": "LBCLDAU", "vid": 50294585622846, "fam": "citrus-lamp-duo", "cover": true, "items": "Puffball Lamp (Blood Orange) + Bubblegum Lamp (Citrus)"},
        {"h": "colour-riot-bundle", "sku": "QB-STAT-4", "vid": 54535617380670, "fam": "colour-riot-bundle", "cover": true, "items": "Bigger Is Better Lamp + Bubblegum Lamp (Citrus) + Spill the Tea Cup and Saucer (Red and Blue) + Fine Ribbed Glass"},
        {"h": "the-originals-trio-bundle", "sku": "QB-ORIG-4", "vid": 54535617511742, "fam": "the-originals-trio-bundle", "cover": true, "items": "Volley Lamp (Clay) + Sunnyboy Lamp (Dirt) + Trunk Lamp (Dirt)"},
        {"h": "sun-court-bundle", "sku": "QB-ORIG-2", "vid": 54535617446206, "fam": "sun-court-bundle", "cover": true, "items": "Volley Lamp (Clay) + Sunnyboy Lamp (Dirt)"},
        {"h": "sunnyboy-dish-bundle", "sku": "QB-ORIG-1", "vid": 54535617413438, "fam": "sunnyboy-dish-bundle", "cover": true, "items": "Sunnyboy Lamp (Burnt) + Billy Dish Snr."},
        {"h": "bubblegum-pair-bundle", "sku": "QB-STAT-2", "vid": 54535617315134, "fam": "bubblegum-pair-bundle", "cover": true, "items": "Bubblegum Lamp (Citrus) + Bubblegum Lamp (Mint)"},
        {"h": "green-street-bundle", "sku": "LHBGSBAU", "vid": 50294662005054, "fam": "green-street-bundle", "cover": true, "items": "Bubblegum Lamp (Mint) + The Grass Is Greener Vase (Lime) + The Grass Is Greener Vase (Matcha) + Spill the Tea Cup and Saucer (Linen and Olive)"},
        {"h": "siren-pair-bundle-ships-late-oct", "sku": "QB-STAT-1", "vid": 54535617282366, "fam": "siren-pair-bundle-ships-late-oct", "cover": true, "items": "Siren Lamp (Blood Orange) + Siren Lamp (Forest Green)"}
      ],
      host: [
        {"h": "the-whole-table-bundle-ships-late-oct", "sku": "QB-HOST-5", "vid": 54535617249598, "fam": "the-whole-table-bundle-ships-late-oct", "cover": true, "items": "Boxy Lamp + Absolutely Necessary Lamp + Billy Dish (Short) + Billy Dish (Tall) + Billy Dish Snr. + The Plaza Tray (Small) + The Plaza Tray (Medium) + The Plaza Tray (Large)"},
        {"h": "dinner-party-bundle", "sku": "LHBDPBAU", "vid": 50294646374718, "fam": "dinner-party-bundle", "cover": true, "items": "Billy Dish (Short) + Billy Dish (Tall) + Butta Dish + Portable Metal Touch Lamp (Aluminium)"},
        {"h": "lamp-tray-dish-bundle-ships-late-oct", "sku": "QB-HOST-2", "vid": 54535617151294, "fam": "lamp-tray-dish-bundle-ships-late-oct", "cover": true, "items": "Absolutely Necessary Lamp + The Plaza Tray (Medium) + Billy Dish (Tall)"},
        {"h": "the-table-kit-bundle", "sku": "QB-HOST-1", "vid": 54535617118526, "fam": "the-table-kit-bundle+table-kit-full-set-bundle", "cover": true, "items": "Billy Dish (Short) + Billy Dish (Tall) + The Plaza Tray (Medium)"},
        {"h": "table-kit-full-set-bundle", "sku": "QB-HOST-3", "vid": 54535617184062, "fam": "the-table-kit-bundle+table-kit-full-set-bundle", "cover": true, "items": "Billy Dish (Short) + Billy Dish (Tall) + Billy Dish Snr. + The Plaza Tray (Small) + The Plaza Tray (Medium) + The Plaza Tray (Large)"},
        {"h": "billy-dish-short-tall-bundle", "sku": "BHBDSHT", "vid": 49098142613822, "fam": "billy-dish-short-tall-bundle", "cover": true, "items": "Billy Dish (Short) + Billy Dish (Tall)"},
        {"h": "boxy-dinner-party-bundle-ships-late-oct", "sku": "QB-HOST-4", "vid": 54535617216830, "fam": "boxy-dinner-party-bundle-ships-late-oct", "cover": true, "items": "Boxy Lamp + Clubroom Tray (Roundish) + Butta Dish + Fine Ribbed Glass"},
        {"h": "mid-century-bundle", "sku": "LHBMCBAU", "vid": 50294637068606, "fam": "mid-century-bundle", "cover": true, "items": "Tube Lamp + Clubroom Tray (Roundish) + Billy Dish (Tall)"},
        {"h": "billy-dish-short-bundle-set-of-4", "sku": "HBBDSB4AU", "vid": 51434401923390, "fam": "billy-dish-short-bundle-set-of-4+billy-dish-tall-bundle-set-of-4", "cover": true, "items": "4 x Billy Dish (Short)"},
        {"h": "billy-dish-tall-bundle-set-of-4", "sku": "HBBDTB4AU", "vid": 51414303080766, "fam": "billy-dish-short-bundle-set-of-4+billy-dish-tall-bundle-set-of-4", "cover": true, "items": "4 x Billy Dish (Tall)"},
        {"h": "the-plaza-tray-set-of-3", "sku": "Plaza-Set-3", "vid": 49095591887166, "fam": "the-plaza-tray-set-of-3", "cover": true, "items": "The Plaza Tray (Large) + The Plaza Tray (Medium) + The Plaza Tray (Small)"},
        {"h": "fine-ribbed-glass-bundle-set-of-4", "sku": "HBFRGB4AU", "vid": 51434420076862, "fam": "fine-ribbed-glass-bundle-set-of-4", "cover": true, "items": "4 x Fine Ribbed Glass"},
        {"h": "clubroom-tray-set-of-3", "sku": "ClubroomTray-Set-3", "vid": 49095603355966, "fam": "clubroom-tray-set-of-3", "cover": true, "items": "Clubroom Tray (Oval) + Clubroom Tray (Pebble) + Clubroom Tray (Roundish)"}
      ],
      gifter: [
        {"h": "the-big-gift-bundle-ships-late-oct", "sku": "QB-GIFT-4", "vid": 54535618068798, "fam": "the-big-gift-bundle-ships-late-oct", "cover": true, "items": "Above the Clouds Lamp + Absolutely Necessary Lamp + Portable Metal Touch Lamp (Aluminium) + Butta Dish + Fine Ribbed Glass + Billy Dish (Tall) + Spill the Tea Cup and Saucer (Egg Yolk)"},
        {"h": "housewarming-bundle-ships-late-oct", "sku": "QB-GIFT-3", "vid": 54535618036030, "fam": "housewarming-bundle-ships-late-oct", "cover": true, "items": "Above the Clouds Lamp + Puffball Lamp (Blood Orange) + Butta Dish"},
        {"h": "best-mates-duo", "sku": "LBBMDAU", "vid": 50294665019710, "fam": "best-mates-duo", "cover": true, "items": "Puffball Lamp (Blood Orange) + Portable Metal Touch Lamp (Brassy Gold)"},
        {"h": "puffball-tea-bundle", "sku": "QB-GIFT-2", "vid": 54535618003262, "fam": "puffball-tea-bundle", "cover": true, "items": "Puffball Lamp (Blood Orange) + Spill the Tea Cup and Saucer (Egg Yolk)"},
        {"h": "desk-dish-bundle-ships-late-oct", "sku": "QB-GIFT-1", "vid": 54535617544510, "fam": "desk-dish-bundle-ships-late-oct", "cover": true, "items": "Portable Metal Touch Lamp (Aluminium) + Billy Dish (Tall)"},
        {"h": "spill-the-tea-cup-and-saucer-set-of-4", "sku": "spill-set-4", "vid": 48347357446462, "fam": "spill-the-tea-cup-and-saucer-set-of-4", "cover": true, "items": "Choose 4: Spill the Tea Cup and Saucer, your colours"},
        {"h": "perfect-cup-bundle", "sku": "perfect-cup-set-4", "vid": 47977585705278, "fam": "perfect-cup-bundle", "cover": true, "items": "Choose 4: Perfect Cup, your colours"},
        {"h": "grassy-vase-duo-lime-matcha", "sku": "HBGVDLMAU", "vid": 51434715808062, "fam": "grassy-vase-duo-lime-matcha+greener-vase-duo-olive-greener", "cover": true, "items": "The Grass Is Greener Vase (Lime) + The Grass Is Greener Vase (Matcha)"},
        {"h": "greener-vase-duo-olive-greener", "sku": "HBGVDOGAU", "vid": 51434840916286, "fam": "grassy-vase-duo-lime-matcha+greener-vase-duo-olive-greener", "cover": true, "items": "The Grass Is Greener Vase (Greener) + The Grass Is Greener Vase (Olive)"}
      ]
    },

    /* A/B knobs. Control = first entry. Variants only ever change these three. */
    ab: {
      control:  { entry: 'inline', incentive: 'none',   order: 'default' },
      b:        { entry: 'inline', incentive: 'guide',  order: 'outcome_first' }
    },

    incentives: {
      none:  '',
      /* was "Plus our Bedside Light guide, free." - there is no such guide. Checked the
         live journal (blogs/stories) on 3 Sep: how-to-light-every-room and
         ambient-lighting-guide both 404. This version promises styling notes the
         result email itself can carry, so nothing has to be built to keep the promise. */
      guide: 'Plus how to style yours, room by room.',
      /* matches the live newsletter popup word for word ("We'll take 10% off your first
         order.") so the quiz and the popup do not offer two different-sounding deals.
         DO NOT SHIP THIS ARM until the email capture actually subscribes the profile and
         the welcome flow delivers a code - see note 3 in QUIZ-COPY-FINAL.md. */
      ten:   "We'll take 10% off your first order."
    },

    /* Arms listed here are NEVER rendered even if a variant asks for them.
       'ten' promises a discount code. The ORIGINAL technical reason for blocking it
       (klaviyoIdentify() identified the profile but never subscribed it, so the
       welcome flow never fired and no code was sent - Copy F-20260903-28, note 3)
       is now fixed: klaviyoSubscribe() below now really does subscribe to Newsletter (WnNAnb), which
       is what triggers DDI Welcome and its YESPLS10 code. 'ten' STAYS BLOCKED anyway:
       showing a 10% offer on the quiz is a customer-facing pricing decision and it is
       Theo's call, not this file's. Deleting 'ten' from the array below is the whole
       change when he says yes (Web Dev F-20260914-21, 15 Sep 2026). */
    incentivesBlocked: ['ten'],

    /* F-20260924-58: 'style' ("Which room feels like yours?") is no longer asked.
       personaKey() and resolveHero() never read it, so it cost every visitor a tap and
       changed nothing about their result. The screen stays in `screens` so it can be
       re-added in one line if the persona re-fit ever scores it; quiz_complete still
       sends a style field (empty) so the event shape does not change. */
    orders: {
      'default':       ['space', 'outcome', 'colour'],
      'outcome_first': ['outcome', 'space', 'colour']
    }
  };

  /* ----------------------------------------------------------- utilities */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* F-20261013-63: two-column set grid on phones. Lives here because this card may only touch
     this file; injected once, before the result paints, so it causes no layout shift.
     Images keep loading=lazy with fixed 1:1 boxes. */
  function ensureSetGridStyle() {
    if (document.getElementById('ddi-quiz-setgrid')) return;
    var st = document.createElement('style');
    st.id = 'ddi-quiz-setgrid';
    st.textContent = '@media screen and (max-width:720px){' +
      '.ddi-quiz .ddi-quiz__pair--sets{grid-template-columns:1fr 1fr;gap:12px;max-width:none}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__card--pair{display:flex;flex-direction:column;padding:0 0 12px;border-top:4px solid var(--ochre,#c8922a)}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__card--pair .ddi-quiz__cardmedia{width:100%}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__card--pair .ddi-quiz__cardtitle{margin:10px 0 0!important;font-size:16px!important}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__bundleitems{margin:4px 0 0;font-size:12px;line-height:1.35;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__price{margin:6px 0 0;font-size:14px}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__stock{margin:4px 0 0;font-size:12px}' +
      '.ddi-quiz .ddi-quiz__pair--sets .ddi-quiz__cta--card{margin-top:auto;min-height:44px;padding:10px 8px;font-size:11px;gap:6px}' +
      '}';
    document.head.appendChild(st);
  }

  /* --------------------------------------------------------- event layer */
  /* F-20260928-43: every event also goes to Shopify Customer Events as 'ddi_<name>'
     (custom pixels subscribe there). Pass `done` when the page is about to leave:
     GA4 gets a beacon + event_callback, and `done` runs on the callback or after
     300ms, whichever comes first, so navigation is never held longer than that. */
  function track(name, params, done) {
    var p = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name, quiz_version: SPEC.version }, p));
    } catch (e) {}
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      done();
    }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, done ? Object.assign({}, p, { transport_type: 'beacon', event_callback: finish }) : p);
      }
    } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, p); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('ddi_' + name, Object.assign({ quiz_version: SPEC.version }, p));
      }
    } catch (e) {}
    try { if (window.DDI_QUIZ_DEBUG) console.log('[ddi-quiz] ' + name, JSON.stringify(p)); } catch (e) {}
    if (done) setTimeout(finish, 300);
  }

  /* ------------------------------------------------------- Klaviyo capture

     Measured on the LIVE page 15 Sep 2026 (Email Campaigns F-20260914-14, Web Dev
     F-20260914-21). Two separate things were broken:

     1. The old window._learnq array API produced ZERO network requests to Klaviyo
        from 6 test addresses. The onsite SDK logs "Klaviyo tracking is disabled"
        on this store, and `identify` alone never creates a profile anyway.
     2. Klaviyo's documented v3 client endpoint (a.klaviyo.com/client/subscriptions)
        CANNOT be called from a browser. Its CORS preflight answers
        `access-control-allow-methods: OPTIONS` - no POST - for every origin tested,
        so Chrome rejects the request before it is sent. Server-to-server the same
        payload returns 202, which is why it looks fine in docs and in curl.

     What works, verified in-page on dennisdidit.com this run: the form-encoded
     endpoint Klaviyo's own embedded signup forms post to. It is a CORS "simple
     request", so there is no preflight to fail, and it returns readable JSON.
     One call creates the profile, records email marketing consent, writes the
     persona property and adds the profile to the list - which is what fires
     "Subscribed to List" and triggers the quiz flow.

     WnNAnb = the "Newsletter" list (single opt-in), the same list the site popup
     uses. No key of any kind is sent from the browser.

     Fire-and-forget by design: the result screen paints whether or not Klaviyo
     answers, so nothing here is awaited and every failure path is swallowed. */
  var KLAVIYO_LIST_ID  = 'WnNAnb';
  var KLAVIYO_SUB_URL  = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  /* F-20261101-02: profile property contract shared with the results-email build. `shown` is
     the lamp + set the result screen actually rendered (never re-derived). Set fields are
     empty strings when the result showed no set. */
  var RESULT_FIELDS = ['DDIQuizLampId', 'DDIQuizLampHandle', 'DDIQuizLampTitle', 'DDIQuizLampImage',
    'DDIQuizSetId', 'DDIQuizSetHandle', 'DDIQuizSetTitle', 'DDIQuizSetImage', 'DDIQuizSetItems',
    'DDIQuizCompletedAt'];
  function klaviyoSubscribe(email, persona, shown) {
    try {
      if (!email) return;
      var fieldNames = 'DDIQuizPersona,$source';
      var extra = '';
      if (shown) {
        fieldNames += ',' + RESULT_FIELDS.join(',');
        RESULT_FIELDS.forEach(function (k) {
          extra += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(shown[k] == null ? '' : String(shown[k]));
        });
      }
      var body = 'g=' + encodeURIComponent(KLAVIYO_LIST_ID) +
                 '&email=' + encodeURIComponent(email) +
                 '&%24fields=' + encodeURIComponent(fieldNames) +
                 '&DDIQuizPersona=' + encodeURIComponent(persona || '') + extra +
                 '&%24source=' + encodeURIComponent('Find Your Light quiz');
      var headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

      if (typeof window.fetch === 'function') {
        window.fetch(KLAVIYO_SUB_URL, {
          method: 'POST', headers: headers, body: body, keepalive: true
        }).then(function (r) {
          return r.json()['catch'](function () { return null; });
        }).then(function (j) {
          track('quiz_email_subscribe_result', {
            persona: persona,
            ok: !!(j && j.success),
            subscribed: !!(j && j.data && j.data.is_subscribed)
          });
        })['catch'](function () {
          /* Response unreadable (offline, blocked, navigated away). The POST itself
             is a simple request, so it may well have been delivered - we just
             cannot confirm it. Record the attempt, never break the result screen. */
          track('quiz_email_subscribe_result', { persona: persona, ok: false, subscribed: false });
        });
        return;
      }

      /* No fetch (very old browser): beacon it and move on. */
      if (navigator && typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon(KLAVIYO_SUB_URL,
          new Blob([body], { type: 'application/x-www-form-urlencoded' }));
        track('quiz_email_subscribe_result', { persona: persona, ok: true, subscribed: false });
      }
    } catch (e) {}
  }

  /* ----------------------------------------------------------------- app */
  function Quiz(root, cfg) {
    this.root = root;
    this.cfg = cfg || {};
    this.products = this.cfg.products || {};
    this.images = this.cfg.images || {};
    this.expId = (this.cfg.ab && this.cfg.ab.experiment_id) || SPEC.version;
    this.variant = this.resolveVariant();
    this.knobs = SPEC.ab[this.variant] || SPEC.ab.control;
    this.order = SPEC.orders[this.knobs.order] || SPEC.orders['default'];
    this.answers = {};
    this.index = 0;
    this.started = false;
    this.locked = false;
    this.reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    this.storeKey = 'ddi_quiz_' + SPEC.version;
    this.restore();
  }

  Quiz.prototype.resolveVariant = function () {
    var v = null;
    try { v = (window._DDI_AB || {})[this.expId] || null; } catch (e) {}
    if (!v) {
      var cls = document.documentElement.className.split(/\s+/);
      for (var i = 0; i < cls.length; i++) {
        if (cls[i].indexOf('exp-' + this.expId + '-') === 0) {
          v = cls[i].slice(('exp-' + this.expId + '-').length);
          break;
        }
      }
    }
    return (v && SPEC.ab[v]) ? v : 'control';
  };

  Quiz.prototype.save = function () {
    try {
      sessionStorage.setItem(this.storeKey, JSON.stringify({ a: this.answers, i: this.index }));
    } catch (e) {}
  };
  Quiz.prototype.restore = function () {
    try {
      var raw = sessionStorage.getItem(this.storeKey);
      if (!raw) return;
      var d = JSON.parse(raw);
      if (d && d.a) { this.answers = d.a; this.index = Math.min(d.i || 0, this.order.length); }
    } catch (e) {}
  };

  Quiz.prototype.screen = function (key) {
    for (var i = 0; i < SPEC.screens.length; i++) if (SPEC.screens[i].key === key) return SPEC.screens[i];
    return null;
  };

  /* image for an option: Files map (theme setting) -> product image -> tone tile */
  Quiz.prototype.optionImage = function (screenKey, opt) {
    var mapped = this.images[screenKey + '.' + opt.v];
    if (mapped) return { src: mapped };
    if (opt.product && this.products[opt.product] && this.products[opt.product].image) {
      return { src: this.products[opt.product].image };
    }
    return { tone: opt.tone || 'var(--img-linen)' };
  };

  /* ------------------------------------------------------------ scoring
     Deliberately a readable rule list, not a weighted model: the v2 strategy says the
     personas get re-fitted after four weeks of real answer data, and you cannot re-fit
     what you cannot read. First rule that matches wins. Every answer is on the
     quiz_step events, so the re-fit has the raw data either way. */
  Quiz.prototype.personaKey = function () {
    var a = this.answers;
    var premium = (a.budget === 'premium' || a.budget === 'open');

    if (a.space === 'gift') return 'gifter';
    if (a.budget === 'open') return 'original';        /* no ceiling -> the Originals */
    if (a.space === 'dining') return 'host';
    if (a.outcome === 'focus') return 'focus';
    if (a.space === 'bedside' && premium) return 'symmetrist';
    if (a.outcome === 'winddown') return 'winddown';
    if (a.outcome === 'mood') return 'nest';
    if (a.outcome === 'statement') return 'statement';
    return 'winddown';
  };

  Quiz.prototype.resolveHero = function (persona) {
    var handle = persona.hero;
    var budget = this.answers.budget;
    var colour = this.answers.colour;
    if (budget && persona.budget && persona.budget[budget]) handle = persona.budget[budget];
    if (colour && persona.colour && persona.colour[colour]) handle = persona.colour[colour];
    if (!this.products[handle]) handle = persona.hero;
    return handle;
  };

  /* --------------------------------------------------------- rendering */
  Quiz.prototype.mount = function () {
    this.root.classList.add('ddi-quiz--' + this.knobs.entry);
    this.root.setAttribute('data-ddi-quiz-variant', this.variant);
    var deep = new URLSearchParams(location.search).get('persona');
    if (deep && SPEC.personas[deep]) { this.forcedPersona = deep; return this.renderResult(); }
    this.render();
  };

  Quiz.prototype.render = function () {
    if (this.index >= this.order.length) return this.renderEmail();
    var key = this.order[this.index];
    var s = this.screen(key);
    var self = this;

    var wrap = el('div', 'ddi-quiz__screen');
    wrap.setAttribute('data-screen', key);

    wrap.appendChild(this.topbar());
    wrap.appendChild(this.progress());

    var h = el('h2', 'ddi-quiz__q', s.question);
    var p = el('p', 'ddi-quiz__sub', s.sub);
    wrap.appendChild(h);
    wrap.appendChild(p);

    var grid = el('div', 'ddi-quiz__grid' + (s.layout === 'list' ? ' ddi-quiz__grid--list' : ''));
    grid.style.setProperty('--ddi-quiz-cols', String(s.options.length));
    s.options.forEach(function (opt) {
      var b = el('button', 'ddi-quiz__opt');
      b.type = 'button';
      b.setAttribute('data-value', opt.v);
      b.setAttribute('data-ab-action', 'quiz_step_' + key);
      b.setAttribute('aria-label', opt.label + '. ' + opt.sub);
      if (self.answers[key] === opt.v) b.classList.add('is-selected');

      var media = el('span', 'ddi-quiz__media');
      var img = s.layout === 'list' ? {} : self.optionImage(key, opt);
      if (s.layout === 'list') {
        media = null;
      } else if (img.src) {
        var im = el('img', 'ddi-quiz__img');
        im.src = img.src;
        im.alt = '';
        im.width = 320; im.height = 320;
        /* Q1 is on screen at load; every later screen is built only when reached and its
           photos were already warmed by preloadNext(), so eager here costs nothing */
        im.loading = self.index === 0 ? 'lazy' : 'eager'; im.decoding = 'async';
        media.appendChild(im);
      } else {
        media.classList.add('ddi-quiz__media--tone');
        media.style.setProperty('--tone', img.tone);
      }
      if (media) b.appendChild(media);

      var lab = el('span', 'ddi-quiz__optlabel', opt.label);
      var sub = el('span', 'ddi-quiz__optsub', opt.sub);
      b.appendChild(lab);
      b.appendChild(sub);

      b.addEventListener('click', function () {
        /* instant feedback: the tapped tile ticks, its siblings step back, THEN the next
           question slides in. A lock stops a double tap answering the next screen too. */
        if (self.locked) return;
        self.locked = true;
        var sibs = grid.querySelectorAll('.ddi-quiz__opt');
        for (var k = 0; k < sibs.length; k++) sibs[k].classList.remove('is-selected');
        b.classList.add('is-selected', 'is-picked');
        grid.classList.add('has-pick');
        setTimeout(function () {
          self.locked = false;
          self.answer(key, opt.v, s.question, opt.label);
        }, self.reduced ? 0 : 280);
      });
      grid.appendChild(b);
    });
    wrap.appendChild(grid);

    this.paint(wrap);
    this.preloadNext();
  };

  /* Warm the NEXT question's photos while the visitor reads this one, so a tap never
     waits on the network. Only one screen ahead: later steps stay unloaded until reached. */
  Quiz.prototype.preloadNext = function () {
    var self = this;
    var key = this.order[this.index + 1];
    var s = key && this.screen(key);
    if (!s || s.layout === 'list') return;
    var go = function () {
      s.options.forEach(function (opt) {
        var img = self.optionImage(key, opt);
        if (img.src) { var i = new Image(); i.decoding = 'async'; i.src = img.src; }
      });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 1500 });
    else setTimeout(go, 400);
  };

  /* F-20261014-24: Back (left) and Start again (right) above the question. Both hold their
     space on question 1 (visibility, not display) so the bar never shifts the page. */
  Quiz.prototype.restart = function () {
    this.answers = {}; this.index = 0; this.forcedPersona = null;
    try { sessionStorage.removeItem(this.storeKey); } catch (e) {}
    this.swap();
  };
  Quiz.prototype.topbar = function () {
    var self = this;
    var bar = el('div', 'ddi-quiz__topbar');
    var first = this.index === 0;
    var back = el('button', 'ddi-quiz__navbtn ddi-quiz__navbtn--back', 'Back');
    back.type = 'button';
    back.setAttribute('aria-label', 'Back to the previous question');
    var again = el('button', 'ddi-quiz__navbtn ddi-quiz__navbtn--again', SPEC.result.restart);
    again.type = 'button';
    if (first) {
      back.classList.add('is-hidden'); back.disabled = true; back.tabIndex = -1;
      again.classList.add('is-hidden'); again.disabled = true; again.tabIndex = -1;
      back.setAttribute('aria-hidden', 'true'); again.setAttribute('aria-hidden', 'true');
    }
    back.addEventListener('click', function () { self.index--; self.save(); self.dir = 'back'; self.swap(); });
    again.addEventListener('click', function () { self.restart(); });
    bar.appendChild(back);
    bar.appendChild(again);
    return bar;
  };

  Quiz.prototype.progress = function () {
    var total = this.order.length + 1; /* + email/result step */
    var done = this.index;
    var bar = el('div', 'ddi-quiz__progress');
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', String(total));
    bar.setAttribute('aria-valuenow', String(done));
    var fill = el('span', 'ddi-quiz__progressfill');
    fill.style.width = Math.round((done / total) * 100) + '%';
    bar.appendChild(fill);
    /* segment ticks over the bar so the visitor can count what is left at a glance */
    bar.style.setProperty('--ddi-quiz-segs', String(total));
    bar.classList.add('ddi-quiz__progress--segs');
    var text = done >= this.order.length
      ? 'Last step'
      : 'Question ' + (done + 1) + ' of ' + this.order.length;
    var lab = el('p', 'ddi-quiz__step', text);
    var box = el('div', 'ddi-quiz__progressbox');
    box.appendChild(bar);
    box.appendChild(lab);
    return box;
  };

  Quiz.prototype.answer = function (key, value, question, label) {
    if (!this.started) {
      this.started = true;
      track('quiz_start', { entry_point: this.knobs.entry, variant: this.variant });
    }
    this.answers[key] = value;
    track('quiz_step', {
      step: this.index + 1,
      question: key,
      question_text: question,
      answer: value,
      answer_text: label,
      variant: this.variant
    });
    this.index++;
    this.save();
    this.swap();
  };

  Quiz.prototype.renderEmail = function () {
    var self = this;
    var persona = this.personaKey();
    this.loadBundles(persona);   /* warm the result's bundles while they type */
    track('quiz_complete', {
      persona: persona,
      budget_band: this.answers.budget || '',
      style: this.answers.style || '',
      space: this.answers.space || '',
      outcome: this.answers.outcome || '',
      colour: this.answers.colour || '',
      variant: this.variant
    });

    var wrap = el('div', 'ddi-quiz__screen ddi-quiz__screen--email');
    wrap.setAttribute('data-screen', 'email');
    wrap.appendChild(this.progress());
    wrap.appendChild(el('h2', 'ddi-quiz__q', SPEC.email.headline));
    wrap.appendChild(el('p', 'ddi-quiz__sub', SPEC.email.body));

    /* incentive line always occupies a box so control and variants match height */
    var arm = this.knobs.incentive;
    if (SPEC.incentivesBlocked.indexOf(arm) !== -1) arm = 'none';
    var inc = el('p', 'ddi-quiz__incentive', SPEC.incentives[arm] || '');
    if (!SPEC.incentives[arm]) inc.classList.add('is-empty');
    wrap.appendChild(inc);

    var form = el('form', 'ddi-quiz__form');
    var input = el('input', 'ddi-quiz__input');
    input.type = 'email';
    input.name = 'email';
    input.placeholder = SPEC.email.placeholder;
    input.setAttribute('aria-label', 'Email address');
    input.autocomplete = 'email';
    var submit = el('button', 'ddi-quiz__cta', SPEC.email.cta);
    submit.type = 'submit';
    submit.setAttribute('data-ab-action', 'quiz_email_submit');
    form.appendChild(input);
    form.appendChild(submit);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { input.classList.add('is-error'); input.focus(); return; }
      track('quiz_email_capture', { persona: persona, variant: self.variant, incentive: self.knobs.incentive });
      /* F-20261101-02: the subscribe now rides on the painted result so it carries the exact
         lamp + set shown (paintResult -> sendPendingSubscribe). Fallback: if the result has not
         painted in 6s, or the tab is closing, send the persona-only subscribe so nobody is lost. */
      self.pendingEmail = { email: v, persona: persona };
      setTimeout(function () { self.sendPendingSubscribe(null); }, 6000);
      try { window.addEventListener('pagehide', function () { self.sendPendingSubscribe(null); }); } catch (e) {}
      self.renderResult();
    });
    wrap.appendChild(form);

    /* What happens to the address. Sits below the input + CTA boxes, so it adds no
       shift to anything already painted. */
    if (SPEC.email.consent) wrap.appendChild(el('p', 'ddi-quiz__consent', SPEC.email.consent));

    var skip = el('button', 'ddi-quiz__skip', SPEC.email.skip);
    skip.type = 'button';
    skip.setAttribute('data-ab-action', 'quiz_email_skip');
    skip.addEventListener('click', function () { self.renderResult(); });
    wrap.appendChild(skip);

    this.paint(wrap);
  };

  Quiz.prototype.card = function (handle, role, personaKey, qty, position, bundleLabel) {
    var self = this;
    var p = this.products[handle];
    var c = el('div', 'ddi-quiz__card ddi-quiz__card--' + role);
    if (!p) {
      c.appendChild(el('p', 'ddi-quiz__cardtitle', handle));
      return c;
    }
    var a = el('a', 'ddi-quiz__cardmedia');
    a.href = p.url;
    a.setAttribute('data-ab-action', 'quiz_result_click');
    if (p.image) {
      var im = el('img', 'ddi-quiz__img');
      im.src = p.image; im.alt = p.title; im.width = 480; im.height = 480;
      im.loading = 'lazy'; im.decoding = 'async';
      a.appendChild(im);
    }
    a.addEventListener('click', function (ev) {
      /* Plain clicks wait for the GA4 hit (max 300ms); new-tab clicks leave the page alone. */
      var plain = !(ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey);
      if (plain) ev.preventDefault();
      track('quiz_result_click', {
        sku: p.sku || handle,
        handle: handle,
        bundle: bundleLabel || '',
        position: position || 1,
        persona: personaKey,
        role: role,
        variant: self.variant
      }, plain ? function () { window.location.href = a.href; } : null);
    });
    c.appendChild(a);

    c.appendChild(el('h3', 'ddi-quiz__cardtitle', p.title + (qty > 1 ? ' x' + qty : '')));

    var price = el('p', 'ddi-quiz__price');
    price.appendChild(el('span', 'ddi-quiz__pricenow', money(p.price * (qty || 1))));
    if (p.compare && p.compare > p.price) {
      price.appendChild(el('span', 'ddi-quiz__pricewas', money(p.compare * (qty || 1))));
      price.appendChild(el('span', 'ddi-quiz__saved', 'You saved ' + money((p.compare - p.price) * (qty || 1))));
    }
    c.appendChild(price);

    var stock = el('p', 'ddi-quiz__stock');
    if (p.available) {
      /* F-20261013-63: pre-order lamps carry "Ships Late Oct" in the title; don't promise same-day */
      stock.textContent = /ships late/i.test(p.title || '') ? SPEC.result.bundleShipsLate : 'In stock - ships same business day';
    } else {
      stock.textContent = 'Out of stock right now';
      stock.classList.add('is-out');
    }
    c.appendChild(stock);
    return c;
  };

  /* ------------------------------------------------------------ bundles
     Resolves the persona's bundles from the live storefront. Never rejects: a
     failed or unpublished bundle is dropped, so the caller sees [] at worst. */
  Quiz.prototype.fetchJSON = function (url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    })['catch'](function () { return null; });
  };
  Quiz.prototype.loadBundles = function (personaKey) {
    var self = this;
    this.bundleCache = this.bundleCache || {};
    var cacheKey = personaKey + '|' + this.answers.space + '|' + this.answers.outcome + '|' + this.answers.colour;
    if (this.bundleCache[cacheKey]) return this.bundleCache[cacheKey];
    var tabKey = SPEC.personaTab && SPEC.personaTab[personaKey];
    if (tabKey && SPEC.tabBundles[tabKey]) return this.loadTabBundles(personaKey, tabKey, cacheKey);
    var defs = (SPEC.bundles[personaKey] || []).slice();
    (SPEC.bundleExtras[personaKey] || []).forEach(function (h) {
      Object.keys(SPEC.bundles).forEach(function (k) {
        SPEC.bundles[k].forEach(function (d) { if (d.h === h && defs.indexOf(d) === -1) defs.push(d); });
      });
    });
    /* own sets (grp 0), then every in-stock set of each persona the answers scored
       (highest score first), then - only if that leaves fewer than minSets - topped up from
       the nearest personas. Each group dearest first. `all` is filled in place so a slow
       network can still paint whatever has arrived (see renderResult). */
    var scored = this.scoredPersonas(personaKey);
    var all = [];
    this.bundleSoFar = this.bundleSoFar || {};
    this.bundleSoFar[personaKey] = all;
    function inStockDearest(got) {
      return got.filter(function (b) { return b && b.available; }).sort(function (x, y) { return y.price - x.price; });
    }
    var p = Promise.all(defs.map(function (d) { return self.resolveBundle(d); })).then(function (list) {
      var seen = {};
      list.forEach(function (b) { if (b) { b.grp = 0; seen[b.def.h] = 1; all.push(b); } });
      /* scored groups: fetched in parallel, appended in score order */
      return Promise.all(scored.map(function (g) {
        return Promise.all((SPEC.bundles[g] || []).filter(function (d) { return !seen[d.h]; })
          .map(function (d) { return self.resolveBundle(d); }));
      })).then(function (groups) {
        groups.forEach(function (got, gi) {
          inStockDearest(got).forEach(function (b) {
            if (seen[b.def.h]) return;
            seen[b.def.h] = 1; b.grp = gi + 1; all.push(b);
          });
        });
        var chain = Promise.resolve();
        (SPEC.related[personaKey] || []).forEach(function (g, ri) {
          if (scored.indexOf(g) !== -1) return;
          chain = chain.then(function () {
            if (all.length >= SPEC.result.minSets) return;
            var more = (SPEC.bundles[g] || []).filter(function (d) { return !seen[d.h]; });
            return Promise.all(more.map(function (d) { return self.resolveBundle(d); })).then(function (got) {
              inStockDearest(got).forEach(function (b) {
                if (all.length >= SPEC.result.minSets || seen[b.def.h]) return;
                seen[b.def.h] = 1; b.grp = 100 + ri; all.push(b);
              });
            });
          });
        });
        return chain.then(function () { return all; });
      });
    });
    this.bundleCache[cacheKey] = p;
    return p;
  };
  /* Round 9: every set in the persona's problem tab (grp 0). Only if fewer than minSets are in stock is it
     topped up from the nearest personas' tabs (grp 100+), so the sets shown always fix the problem picked. */
  Quiz.prototype.loadTabBundles = function (personaKey, tabKey, cacheKey) {
    var self = this, all = [], seen = {};
    this.bundleSoFar = this.bundleSoFar || {};
    this.bundleSoFar[personaKey] = all;
    var p = Promise.all(SPEC.tabBundles[tabKey].map(function (d) { return self.resolveBundle(d); })).then(function (list) {
      list.forEach(function (b) { if (b && b.available) { b.grp = 0; seen[b.def.h] = 1; all.push(b); } });
      var chain = Promise.resolve(), used = {}; used[tabKey] = 1;
      (SPEC.related[personaKey] || []).forEach(function (g, ri) {
        var t = SPEC.personaTab[g];
        if (!t || used[t]) return; used[t] = 1;
        chain = chain.then(function () {
          if (all.length >= SPEC.result.minSets) return;
          var more = SPEC.tabBundles[t].filter(function (d) { return !seen[d.h]; });
          return Promise.all(more.map(function (d) { return self.resolveBundle(d); })).then(function (got) {
            got.filter(function (b) { return b && b.available; }).sort(function (x, y) { return y.price - x.price; }).forEach(function (b) {
              if (all.length >= SPEC.result.minSets || seen[b.def.h]) return;
              seen[b.def.h] = 1; b.grp = 100 + ri; all.push(b);
            });
          });
        });
      });
      return chain.then(function () { return all; });
    });
    this.bundleCache[cacheKey] = p;
    return p;
  };
  /* personas the answers point at, other than the result persona, highest score first
     (ties keep SPEC.related order) */
  Quiz.prototype.scoredPersonas = function (personaKey) {
    var a = this.answers, score = {};
    Object.keys(SPEC.answerPersonas).forEach(function (q) {
      ((SPEC.answerPersonas[q] || {})[a[q]] || []).forEach(function (k) { score[k] = (score[k] || 0) + 1; });
    });
    var rel = SPEC.related[personaKey] || [];
    return rel.filter(function (k) { return score[k] > 0; })
      .map(function (k, i) { return { k: k, s: score[k], i: i }; })
      .sort(function (x, y) { return (y.s - x.s) || (x.i - y.i); })
      .map(function (x) { return x.k; });
  };
  Quiz.prototype.resolveBundle = function (d) {
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return self.fetchJSON(root + 'products/' + d.h + '.js').then(function (j) {
      if (!j || !j.variants || !j.variants.length) return null;
      var v = j.variants[0];
      /* guard: the handle must still be the bundle we signed off */
      if (v.id !== d.vid) return null;
      var b = { def: d, pid: j.id, cdnImage: j.featured_image || '', title: String(j.title || '').split('|')[0].trim(),
                late: /ships late/i.test(j.title || ''), url: j.url || (root + 'products/' + d.h),
                price: v.price, compare: v.compare_at_price || 0, available: !!v.available,
                image: (d.cover && ASSET_BASE) ? ASSET_BASE + 'bf-cover-' + d.h + '.jpg' : (j.featured_image || null) };
      if (b.image) return b;
      var cached = self.products[d.img];
      if (cached && cached.image) { b.image = cached.image; return b; }
      return self.fetchJSON(root + 'products/' + d.img + '.js').then(function (im) {
        b.image = (im && im.featured_image) || null;
        return b;
      });
    });
  };
  /* F-20261013-63: two more single lamps beside the matched one. Candidates: lamps that
     headline this persona's sets, then the nearest personas' heroes and set lamps. Skips
     the hero's lamp family (a colour of the same lamp is not a second pick), duplicates,
     404s and anything out of stock. Resolves to up to `need` product records. */
  Quiz.prototype.loadLampPicksLegacy = function (personaKey, heroHandle, need) {
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var order = [];
    function add(h) { if (h && /lamp/i.test(h) && order.indexOf(h) === -1) order.push(h); }
    function fromSets(k) { (SPEC.bundles[k] || []).forEach(function (d) { add(d.img); }); }
    fromSets(personaKey);
    (SPEC.bundleExtras[personaKey] || []).forEach(function (h) {
      Object.keys(SPEC.bundles).forEach(function (k) {
        SPEC.bundles[k].forEach(function (d) { if (d.h === h) add(d.img); });
      });
    });
    (SPEC.related[personaKey] || []).forEach(function (k) {
      add((SPEC.personas[k] || {}).hero);
      fromSets(k);
    });
    function family(t) { return String(t || '').split('|')[0].trim().toLowerCase(); }
    var heroP = this.products[heroHandle];
    var fams = {};
    if (heroP) fams[family(heroP.title)] = 1;
    var picks = [];
    var chain = Promise.resolve();
    order.forEach(function (h) {
      chain = chain.then(function () {
        if (picks.length >= need || h === heroHandle) return;
        var cached = self.products[h];
        var get = cached ? Promise.resolve(cached) : self.fetchJSON(root + 'products/' + h + '.js').then(function (j) {
          if (!j || !j.variants || !j.variants.length) return null;
          var v = j.variants[0];
          var img = j.featured_image || '';
          if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=640';
          return { url: j.url || (root + 'products/' + h), image: img, title: j.title, price: v.price,
                   compare: v.compare_at_price || 0, available: !!v.available, variant_id: v.id,
                   sku: v.sku || h, is_light: true };
        });
        return get.then(function (p) {
          if (!p || !p.available || fams[family(p.title)]) return;
          fams[family(p.title)] = 1;
          self.products[h] = p;
          picks.push(h);
        });
      });
    });
    return chain.then(function () { return picks; });
  };
  /* F-20261014-24: picks 2 and 3 are SCORED against the answers over the live lamp catalogue
     (Theo 14 Oct: Metal asked, timber and white paper shown). Colour outranks everything:
     one colour hit (10) beats style + space + outcome + set bonus + best-seller (4+2+2+1+1).
     Title is the colour signal (tags are noisy: a paper Boxy carries "metal"). One entry per
     lamp family (best-scoring colourway wins), never the hero's family. */
  var LAMP_COLOUR = {
    metal:   /metal|brass|aluminium|chrome|brushed|gold|steel/i,
    warm:    /orange|burnt|blood|toasted|rust|terracotta/i,
    green:   /green|grass|forest|leafy|matcha|olive|lime/i,
    neutral: /white|snow|clay|beech|oak|natural|cream|dirt/i
  };
  var W = { colour: 10, colourTag: 4, style: 4, space: 2, outcome: 2, setBonus: 1, best: 1, late: -1 };
  function tagSet(p) { var o = {}; (p.tags || []).forEach(function (t) { o[String(t).toLowerCase()] = 1; }); return o; }
  function anyTag(t, list) { for (var i = 0; i < list.length; i++) if (t[list[i]]) return true; return false; }
  Quiz.prototype.scoreLamp = function (c, a) {
    var t = tagSet(c), name = c.title + ' ' + c.handle, sc = 0;
    var col = a.colour;
    if (col && LAMP_COLOUR[col]) {
      if (LAMP_COLOUR[col].test(c.title)) sc += W.colour;
      else if (col === 'metal' && t.chrome) sc += W.colourTag;
      else if (col === 'neutral' && anyTag(t, ['rice paper', 'washi', 'linen', 'oak'])) sc += W.colourTag;
    }
    var st = a.style;
    if (st === 'warmmin' && anyTag(t, ['minimal', 'minimalist'])) sc += W.style;
    else if (st === 'japandi' && anyTag(t, ['japandi', 'paper', 'timber', 'wood', 'linen'])) sc += W.style;
    else if (st === 'midcent' && (/walnut|brass|brushed|gold|trunk|hoist/i.test(name) || anyTag(t, ['wood', 'chrome']))) sc += W.style;
    else if (st === 'playful' && (/citrus|mint|orange|green|bubblegum|ribbon|siren/i.test(name) || t.statement)) sc += W.style;
    var sp = a.space;
    if (sp === 'bedside' && anyTag(t, ['cordless', 'portable', 'night light'])) sc += W.space;
    else if (sp === 'desk' && (/hoist|trunk|metal touch/i.test(name) || t['desk lamp'])) sc += W.space;
    else if (sp === 'living' && anyTag(t, ['floor lamp', 'standing lamp', 'statement'])) sc += W.space;
    else if (sp === 'dining' && anyTag(t, ['dome', 'glass', 'cordless'])) sc += W.space;
    else if (sp === 'gift' && t['best seller']) sc += W.space;
    var oc = a.outcome;
    if (oc === 'winddown' && anyTag(t, ['dome', 'organic', 'paper', 'linen', 'fabric'])) sc += W.outcome;
    else if (oc === 'focus' && (/hoist|trunk|metal touch/i.test(name) || t.chrome)) sc += W.outcome;
    else if (oc === 'mood' && anyTag(t, ['glass', 'dome', 'accent'])) sc += W.outcome;
    else if (oc === 'statement' && anyTag(t, ['statement', 'sculptural', 'floor lamp'])) sc += W.outcome;
    if (c.inSets) sc += W.setBonus;
    if (t['best seller']) sc += W.best;
    if (/ships late/i.test(c.title)) sc += W.late;
    return sc;
  };
  /* compact catalogue records, cached for the visit. Prices are cents, like .js. */
  Quiz.prototype.loadCatalogue = function () {
    if (this.catalogueP) return this.catalogueP;
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ckey = 'ddi_quiz_lamps_v1';
    try {
      var hit = JSON.parse(sessionStorage.getItem(ckey) || 'null');
      if (hit && hit.length) return (this.catalogueP = Promise.resolve(hit));
    } catch (e) {}
    this.catalogueP = this.fetchJSON(root + 'collections/lamps/products.json?limit=250&sort_by=best-selling').then(function (j) {
      var out = [];
      ((j && j.products) || []).forEach(function (p, i) {
        var tags = p.tags || [];
        if (tags.join('|').search(/(^|\|)(Bundles|QuizBundle|BundleBuilder)(\||$)/i) !== -1) return;
        if (!/^lamp$/i.test(p.product_type || '') || /bundle|duo|trio|gift card|globe/i.test(p.title)) return;
        var v = (p.variants || [])[0];
        if (!v || !v.available) return;
        var img = p.images && p.images[0] ? p.images[0].src : '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=640';
        out.push({ handle: p.handle, title: p.title, tags: tags, rank: i,
                   url: root + 'products/' + p.handle, image: img,
                   price: Math.round(parseFloat(v.price) * 100) || 0,
                   compare: Math.round(parseFloat(v.compare_at_price) * 100) || 0,
                   available: true, variant_id: v.id, sku: v.sku || p.handle, is_light: true });
      });
      if (out.length) { try { sessionStorage.setItem(ckey, JSON.stringify(out)); } catch (e) {} }
      return out;
    });
    return this.catalogueP;
  };
  Quiz.prototype.loadLampPicks = function (personaKey, heroHandle, need) {
    var self = this;
    var legacy = function () { return self.loadLampPicksLegacy(personaKey, heroHandle, need); };
    function family(t) { return String(t || '').split('|')[0].trim().toLowerCase(); }
    var inSets = {};
    (SPEC.bundles[personaKey] || []).forEach(function (d) { if (d.img) inSets[d.img] = 1; });
    return this.loadCatalogue().then(function (cat) {
      if (!cat || !cat.length) return legacy();
      var heroP = self.products[heroHandle];
      var heroFam = family(heroP ? heroP.title : '');
      var best = {};
      cat.forEach(function (c) {
        if (c.handle === heroHandle) return;
        var fam = family(c.title);
        if (fam === heroFam) return;
        c.inSets = !!inSets[c.handle];
        var sc = self.scoreLamp(c, self.answers);
        var cur = best[fam];
        if (!cur || sc > cur.sc || (sc === cur.sc && c.rank < cur.c.rank)) best[fam] = { c: c, sc: sc };
      });
      var ranked = Object.keys(best).map(function (k) { return best[k]; })
        .sort(function (x, y) { return (y.sc - x.sc) || (x.c.rank - y.c.rank); });
      var picks = [];
      ranked.slice(0, need).forEach(function (r) {
        var c = r.c;
        self.products[c.handle] = { url: c.url, image: c.image, title: c.title, price: c.price, compare: c.compare,
          available: true, variant_id: c.variant_id, sku: c.sku, is_light: true };
        picks.push(c.handle);
      });
      if (picks.length >= need) return picks;
      /* never fewer than 2: top up from the old ordering, skipping what we already chose */
      return legacy().then(function (more) {
        more.forEach(function (h) { if (picks.length < need && picks.indexOf(h) === -1) picks.push(h); });
        return picks;
      });
    })['catch'](legacy);
  };
  /* F-20261013-29: highest live price first (stable on ties); the featured set is the
     dearest one that is in stock, or the dearest overall when none is. */
  Quiz.prototype.sortBundles = function (list) {
    var famTop = {};
    list.forEach(function (b) { var f = b.def.fam || b.def.h; famTop[f] = Math.max(famTop[f] || 0, b.price); });
    return list.map(function (b, i) { return { b: b, i: i, f: b.def.fam || b.def.h }; })
      .sort(function (x, y) { return ((x.b.grp || 0) - (y.b.grp || 0)) || (famTop[y.f] - famTop[x.f]) ||
                                     (x.f < y.f ? -1 : x.f > y.f ? 1 : 0) || (y.b.price - x.b.price) || (x.i - y.i); })
      .map(function (x) { return x.b; });
  };
  /* F-20261013-63: the featured set always comes from the persona's own group (grp 0),
     falling back to the whole list only if none of its own loaded. */
  Quiz.prototype.featuredBundle = function (sorted) {
    if (!sorted.length) return null;
    var own = sorted.filter(function (b) { return !b.grp; });
    var pool = own.length ? own : sorted;
    for (var i = 0; i < pool.length; i++) if (pool[i].available) return pool[i];
    return pool[0];
  };
  Quiz.prototype.bundleCard = function (b, personaKey, position, role) {
    var self = this;
    var c = el('div', 'ddi-quiz__card ddi-quiz__card--pair ddi-quiz__card--bundle');
    var a = el('a', 'ddi-quiz__cardmedia');
    a.href = b.url;
    a.setAttribute('data-ab-action', 'quiz_result_click');
    if (b.image) {
      var im = el('img', 'ddi-quiz__img');
      im.src = b.image + (b.image.indexOf('?') === -1 ? '?' : '&') + 'width=640';
      im.alt = b.title; im.width = 480; im.height = 480;
      im.loading = 'lazy'; im.decoding = 'async';
      a.appendChild(im);
    }
    a.addEventListener('click', function (ev) {
      var plain = !(ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey);
      if (plain) ev.preventDefault();
      track('quiz_result_click', {
        sku: b.def.sku, handle: b.def.h, bundle: b.title, position: position,
        persona: personaKey, role: role, variant: self.variant
      }, plain ? function () { window.location.href = a.href; } : null);
    });
    c.appendChild(a);
    c.appendChild(el('h3', 'ddi-quiz__cardtitle', b.title));
    c.appendChild(el('p', 'ddi-quiz__bundleitems', b.def.items));
    var price = el('p', 'ddi-quiz__price');
    price.appendChild(el('span', 'ddi-quiz__pricenow', money(b.price)));
    if (b.compare > b.price) {
      price.appendChild(el('span', 'ddi-quiz__pricewas', money(b.compare)));
      price.appendChild(el('span', 'ddi-quiz__saved', 'You save ' + money(b.compare - b.price)));
    }
    c.appendChild(price);
    var stock = el('p', 'ddi-quiz__stock');
    if (!b.available) { stock.textContent = 'Out of stock right now'; stock.classList.add('is-out'); }
    else stock.textContent = b.late ? SPEC.result.bundleShipsLate : 'In stock - ships same business day';
    c.appendChild(stock);
    return c;
  };
  Quiz.prototype.bundleCta = function (b, personaKey, cls, label) {
    var self = this;
    var btn = el('button', 'ddi-quiz__cta ' + cls);
    btn.type = 'button';
    /* same A/B action as the old pair button, so the quiz-v1 metric carries over */
    btn.setAttribute('data-ab-action', 'quiz_atc_pair');
    if (b.available) {
      btn.textContent = label;
      btn.addEventListener('click', function () {
        self.addToCart([{ id: b.def.vid, qty: 1, sku: b.def.sku, price: b.price }], personaKey, b.title, btn);
        track('quiz_pair_total', { persona: personaKey, bundle: b.title, variant: self.variant,
                                   value: b.price / 100, rrp: (b.compare || b.price) / 100,
                                   saving: Math.max(0, b.compare - b.price) / 100, currency: 'AUD' });
      });
    } else {
      btn.textContent = 'Out of stock right now';
      btn.disabled = true;
    }
    return btn;
  };
  /* Featured bundle + the persona's other bundles. Simple Bundles products take no
     multi-buy ladder discount at cart or checkout (measured F-20261001-03), so the
     bundle price IS the charge - nothing here applies the ladder. */
  Quiz.prototype.renderBundles = function (wrap, key, list) {
    var self = this;
    list = this.sortBundles(list);
    var feat = this.featuredBundle(list);
    this.shownSet = feat;   /* F-20261101-02: exactly the set the result leads with */
    wrap.appendChild(el('h3', 'ddi-quiz__sectiontitle', SPEC.result.bundleTitle));
    var box = el('div', 'ddi-quiz__pair ddi-quiz__pair--single');
    box.appendChild(this.bundleCard(feat, key, 2, 'bundle_featured'));
    wrap.appendChild(box);
    wrap.appendChild(el('p', 'ddi-quiz__pairnote', SPEC.result.bundleNote));

    var saving = feat.compare - feat.price;
    var totalBox = el('div', 'ddi-quiz__total');
    var totalRow = el('div', 'ddi-quiz__totalrow');
    totalRow.appendChild(el('span', 'ddi-quiz__totallabel', SPEC.result.bundleTotalLabel));
    var priceWrap = el('span', 'ddi-quiz__totalprice');
    priceWrap.appendChild(el('span', 'ddi-quiz__totalnow', money(feat.price)));
    if (saving > 0) priceWrap.appendChild(el('s', 'ddi-quiz__totalwas', money(feat.compare)));
    totalRow.appendChild(priceWrap);
    totalBox.appendChild(totalRow);
    var saveLine = el('p', 'ddi-quiz__totalsave',
      saving > 0 ? SPEC.result.bundleTotalSave.replace('{saving}', money(saving)) : '');
    if (saving <= 0) saveLine.classList.add('is-empty');
    totalBox.appendChild(saveLine);
    wrap.appendChild(totalBox);
    wrap.appendChild(this.bundleCta(feat, key, 'ddi-quiz__cta--outline',
      'Add the ' + feat.title.replace(/^the[ ]+/i, '') + ' - ' + money(feat.price)));

    var others = list.filter(function (b) { return b !== feat; });
    if (others.length) {
      wrap.appendChild(el('h3', 'ddi-quiz__sectiontitle', SPEC.result.bundleOtherTitle));
      ensureSetGridStyle();
      var grid = el('div', 'ddi-quiz__pair ddi-quiz__pair--sets');
      others.forEach(function (b, i) {
        var card = self.bundleCard(b, key, i + 3, 'bundle');
        card.appendChild(self.bundleCta(b, key, 'ddi-quiz__cta--outline ddi-quiz__cta--card',
          'Add - ' + money(b.price)));
        grid.appendChild(card);
      });
      wrap.appendChild(grid);
    }
  };

  Quiz.prototype.addToCart = function (items, personaKey, bundleLabel, btn) {
    var self = this;
    var payload = { items: items.map(function (i) { return { id: i.id, quantity: i.qty }; }) };
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function () {
      /* F-20261002-03: tag the CART (not the lines - Simple Bundles explodes lines at checkout)
         so the order carries the quiz persona into note_attributes. Leading underscore hides
         them, same as the _exp_* / _ddi_vid attributes. A failed tag never blocks the add.
         Shopify drops a blank attribute, so a hero-only add records bundle 'single'. */
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: {
          _ddi_quiz_persona: personaKey || '',
          _ddi_quiz_bundle: bundleLabel || 'single',
          _ddi_quiz_variant: self.variant || ''
        } })
      }).catch(function () {});
    }).then(function () {
      track('quiz_atc', {
        sku: items.map(function (i) { return i.sku; }).join('+'),
        bundle: bundleLabel || '',
        persona: personaKey,
        variant: self.variant,
        value: items.reduce(function (s, i) { return s + (i.price * i.qty) / 100; }, 0),
        currency: 'AUD'
      });
      btn.textContent = 'Added';
      try { document.dispatchEvent(new CustomEvent('ddi:cart:refresh')); } catch (e) {}
      if ((self.cfg.settings || {}).cart_redirect !== false) {
        setTimeout(function () { window.location.href = '/cart'; }, 600);
      }
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = label;
      var err = $('.ddi-quiz__error', self.root);
      if (err) err.textContent = 'That did not add. Try the product page.';
    });
  };

  Quiz.prototype.renderResult = function () {
    var self = this;
    var key = this.forcedPersona || this.personaKey();
    if (this.resultPending) return;
    this.resultPending = true;
    /* usually already loaded from the email screen; never hold the result > 2.5s */
    var timeout = new Promise(function (res) {
      setTimeout(function () { res(((self.bundleSoFar || {})[key] || []).slice()); }, 3500);
    });
    var picksP = this.loadLampPicks(key, this.resolveHero(SPEC.personas[key]), 2)['catch'](function () { return []; });
    var picksTimeout = new Promise(function (res) { setTimeout(function () { res([]); }, 3500); });
    Promise.all([Promise.race([this.loadBundles(key), timeout]), Promise.race([picksP, picksTimeout])]).then(function (r) {
      self.resultPending = false;
      self.paintResult(key, r[0] || [], r[1] || []);
    });
  };

  Quiz.prototype.paintResult = function (key, bundles, picks) {
    var self = this;
    var persona = SPEC.personas[key];
    var heroHandle = this.resolveHero(persona);
    var hero = this.products[heroHandle];

    this.shownSet = null;
    var wrap = el('div', 'ddi-quiz__screen ddi-quiz__screen--result ddi-quiz__screen--reveal');
    wrap.setAttribute('data-screen', 'result');
    wrap.setAttribute('data-persona', key);

    wrap.appendChild(el('p', 'ddi-quiz__eyebrow', SPEC.result.eyebrow));
    wrap.appendChild(el('h2', 'ddi-quiz__persona', persona.name));
    wrap.appendChild(el('p', 'ddi-quiz__blurb', persona.blurb));

    /* round 9: the sets lead the result */
    if (bundles.length) this.renderBundles(wrap, key, bundles);

    /* hero */
    wrap.appendChild(el('h3', 'ddi-quiz__sectiontitle', bundles.length ? SPEC.result.lampTitle : SPEC.result.heroTitle));
    wrap.appendChild(this.card(heroHandle, 'hero', key, 1, 1, ''));

    var heroCta = el('button', 'ddi-quiz__cta ddi-quiz__cta--solid');
    heroCta.type = 'button';
    heroCta.setAttribute('data-ab-action', 'quiz_atc_hero');
    if (hero && hero.available && hero.variant_id) {
      heroCta.textContent = 'Add ' + hero.title.split('|')[0].trim() + ' - ' + money(hero.price);
      heroCta.addEventListener('click', function () {
        self.addToCart([{ id: hero.variant_id, qty: 1, sku: hero.sku || heroHandle, price: hero.price }], key, '', heroCta);
      });
    } else {
      heroCta.textContent = 'See the lamp';
      heroCta.addEventListener('click', function () {
        track('quiz_result_click', { sku: (hero && hero.sku) || heroHandle, handle: heroHandle, persona: key, role: 'hero_oos' }, function () {
          window.location.href = hero ? hero.url : '/collections/all';
        });
      });
    }
    wrap.appendChild(heroCta);

    /* F-20261013-63: lamp picks 2 and 3, link to their pages (same compact rows as the sets) */
    if (picks && picks.length) {
      wrap.appendChild(el('h3', 'ddi-quiz__sectiontitle', SPEC.result.picksTitle));
      var picksBox = el('div', 'ddi-quiz__pair');
      picks.forEach(function (h, i) {
        var pc = self.card(h, 'lamp_pick', key, 1, i + 2, '');
        pc.classList.add('ddi-quiz__card--pair');
        picksBox.appendChild(pc);
      });
      wrap.appendChild(picksBox);
    }

    /* (round 9: the sets now render above the lamp; the old pair block is still the fallback) */

    /* pair */
    var pair = bundles.length ? { items: [] } : (persona.pair || { items: [] });
    var counts = {};
    pair.items.forEach(function (h) { counts[h] = (counts[h] || 0) + 1; });
    var handles = Object.keys(counts);
    var resolved = handles.map(function (h) { return { h: h, p: self.products[h], qty: counts[h] }; })
                          .filter(function (x) { return !!x.p; });

    if (resolved.length) {
      wrap.appendChild(el('h3', 'ddi-quiz__sectiontitle', SPEC.result.pairTitle));
      /* a same-lamp pair (Bedside Twins) resolves to ONE card at qty 2 - don't leave
         it sitting in half a two-column grid */
      var pairBox = el('div', 'ddi-quiz__pair' + (resolved.length === 1 ? ' ddi-quiz__pair--single' : ''));
      resolved.forEach(function (x, i) {
        pairBox.appendChild(self.card(x.h, 'pair', key, x.qty, i + 2, pair.label));
      });
      wrap.appendChild(pairBox);
      wrap.appendChild(el('p', 'ddi-quiz__pairnote', SPEC.result.pairNote));

      /* ---- what the pair costs, and what it saves against RRP -------------------
         `total` is what we charge: persona.pair.bundlePrice (cents) when a curated
         bundle price exists, otherwise the sum of the live item prices. `rrp` is the
         sum of compare-at, falling back to price where a product has no compare-at,
         so the saving can never be overstated. When curated bundle retail pricing
         lands from Profit Tracking, set bundlePrice on the persona's pair and this
         block reprices with no other change. */
      /* MULTI-BUY LADDER (F-20260908-13, 10 Sep 2026).
         The store's discount app applies a quantity ladder automatically at cart, so
         the plain sum of two prices OVERSTATED the pair: the quiz said $428 for a pair
         the cart charged $363.80. This mirrors sections/ddi-pdp-hero.liquid exactly -
         same ladders, and the same rule Theo set on 21 Aug: the ladder and a storewide
         sale do NOT stack, the LARGER wins, and every line is priced off RRP. Keep the
         two in step; if the ladder changes there, change it here. */
      var MB_LADDER = {
        light: { qtys: [1, 2, 3, 4], pcts: [0, 15, 20, 25] },
        home:  { qtys: [1, 2, 4, 6], pcts: [0, 10, 20, 30] }
      };
      function mbIsLight(p, handle) {
        /* is_light comes from ddi-quiz.liquid. Fall back to the handle/title so a page
           served from cache before that file lands still classifies a lamp as a lamp. */
        if (typeof p.is_light === 'boolean') return p.is_light;
        return /lamp|light/i.test(String(handle || '') + ' ' + String(p.title || ''));
      }
      function mbPct(kind, qty) {
        /* F-20261029-78: multi-buy kill switch on = no ladder at cart, so price none. */
        if ((self.cfg.settings || {}).multibuy_off === true) return 0;
        var t = MB_LADDER[kind], pct = 0;
        for (var i = 0; i < t.qtys.length; i++) if (qty >= t.qtys[i]) pct = t.pcts[i];
        return pct;
      }
      var mbQty = { light: 0, home: 0 };
      resolved.forEach(function (x) {
        mbQty[mbIsLight(x.p, x.h) ? 'light' : 'home'] += x.qty;
      });
      var sumPrice = resolved.reduce(function (s, x) {
        var kind = mbIsLight(x.p, x.h) ? 'light' : 'home';
        var c = (x.p.compare && x.p.compare > x.p.price) ? x.p.compare : x.p.price;
        var salePct = c > 0 ? Math.round((c - x.p.price) * 100 / c) : 0;
        var pct = Math.max(salePct, mbPct(kind, mbQty[kind]));
        return s + Math.round(c * (100 - pct) / 100) * x.qty;
      }, 0);
      var rrp = resolved.reduce(function (s, x) {
        var c = (x.p.compare && x.p.compare > x.p.price) ? x.p.compare : x.p.price;
        return s + c * x.qty;
      }, 0);
      var total = (pair.bundlePrice != null && !isNaN(pair.bundlePrice)) ? pair.bundlePrice : sumPrice;
      var saving = rrp - total;

      var totalBox = el('div', 'ddi-quiz__total');
      var totalRow = el('div', 'ddi-quiz__totalrow');
      totalRow.appendChild(el('span', 'ddi-quiz__totallabel', SPEC.result.totalLabel));
      var priceWrap = el('span', 'ddi-quiz__totalprice');
      priceWrap.appendChild(el('span', 'ddi-quiz__totalnow', money(total)));
      if (saving > 0) priceWrap.appendChild(el('s', 'ddi-quiz__totalwas', money(rrp)));
      totalRow.appendChild(priceWrap);
      totalBox.appendChild(totalRow);
      /* the save line holds its box in both states so an RRP-less pair does not
         shorten the card and shift the button under it */
      var saveLine = el('p', 'ddi-quiz__totalsave',
        saving > 0 ? SPEC.result.totalSave.replace('{saving}', money(saving)) : '');
      if (saving <= 0) saveLine.classList.add('is-empty');
      totalBox.appendChild(saveLine);
      wrap.appendChild(totalBox);

      var allIn = resolved.every(function (x) { return x.p.available && x.p.variant_id; });
      var pairCta = el('button', 'ddi-quiz__cta ddi-quiz__cta--outline');
      pairCta.type = 'button';
      pairCta.setAttribute('data-ab-action', 'quiz_atc_pair');
      if (allIn) {
        pairCta.textContent = 'Add the ' + pair.label + ' - ' + money(total);
        pairCta.addEventListener('click', function () {
          self.addToCart(resolved.map(function (x) {
            return { id: x.p.variant_id, qty: x.qty, sku: x.p.sku || x.h, price: x.p.price };
          }), key, pair.label, pairCta);
          /* quiz_atc reports the line prices; the pair total is reported alongside it
             so a curated bundle price is visible in the data from day one */
          track('quiz_pair_total', { persona: key, bundle: pair.label, variant: self.variant,
                                     value: total / 100, rrp: rrp / 100, saving: saving / 100,
                                     currency: 'AUD' });
        });
      } else {
        pairCta.textContent = 'One of these is out of stock';
        pairCta.disabled = true;
      }
      wrap.appendChild(pairCta);
    }

    wrap.appendChild(el('p', 'ddi-quiz__error', ''));

    var again = el('button', 'ddi-quiz__skip', SPEC.result.restart);
    again.type = 'button';
    again.addEventListener('click', function () { self.restart(); });
    wrap.appendChild(again);

    /* F-20261013-63: the very last thing on the result, after every set. Plain link, no event. */
    var browse = el('a', 'ddi-quiz__cta ddi-quiz__cta--outline ddi-quiz__browseall', SPEC.result.browseAll);
    browse.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + SPEC.result.browseAllUrl;
    wrap.appendChild(browse);

    this.paint(wrap);
    this.afterResultPainted(key, heroHandle, hero);
  };

  /* F-20261101-02: runs after the result is on screen. Never awaited by the paint, errors swallowed. */
  Quiz.prototype.afterResultPainted = function (key, heroHandle, hero) {
    var self = this;
    var completedAt = new Date().toISOString();
    /* 1. stamp the cart (no line added) so an order carries the quiz persona even if the shopper
          buys from a product page. Attribute writes merge, so the add-to-cart attributes still land. */
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _ddi_quiz_persona: key || '', _ddi_quiz_completed: completedAt } }),
        keepalive: true
      })['catch'](function () {});
    } catch (e) {}
    /* 2. build the shown-lamp + shown-set record for Klaviyo (only if an email was captured) */
    if (!this.pendingEmail) return;
    var set = this.shownSet;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function https(u) {
      u = String(u || '');
      if (!u) return '';
      if (u.indexOf('//') === 0) return 'https:' + u;
      if (u.charAt(0) === '/') return location.origin + u;
      return u.replace(/^http:/, 'https:');
    }
    function build(lampId) {
      return {
        DDIQuizLampId: lampId || '',
        DDIQuizLampHandle: heroHandle || '',
        DDIQuizLampTitle: hero ? String(hero.title || '') : '',
        DDIQuizLampImage: hero ? https(hero.image) : '',
        DDIQuizSetId: set ? (set.pid || '') : '',
        DDIQuizSetHandle: set ? set.def.h : '',
        DDIQuizSetTitle: set ? set.title : '',
        DDIQuizSetImage: set ? https(set.cdnImage || set.image) : '',   /* product photo on the Files CDN: survives a theme switch, unlike the theme-asset cover */
        DDIQuizSetItems: set ? set.def.items : '',
        DDIQuizCompletedAt: completedAt
      };
    }
    var done = false;
    function go(id) { if (done) return; done = true; self.sendPendingSubscribe(build(id)); }
    /* numeric product id of the lamp comes from its public .js (cached by the browser from the page) */
    setTimeout(function () { go(''); }, 1500);
    this.fetchJSON(root + 'products/' + heroHandle + '.js').then(function (j) { go(j && j.id ? j.id : ''); });
  };

  /* One subscribe per capture: first caller wins (result-painted record, else the persona-only fallback). */
  Quiz.prototype.sendPendingSubscribe = function (shown) {
    var p = this.pendingEmail;
    if (!p) return;
    this.pendingEmail = null;
    klaviyoSubscribe(p.email, p.persona, shown);
  };

  Quiz.prototype.swap = function () {
    if (this.index >= this.order.length) this.renderEmail();
    else this.render();
  };

  Quiz.prototype.paint = function (node) {
    /* enter transition: 200ms fade + 12px slide, reversed for Back. Opacity/transform
       only, so it moves no layout box (CLS 0). Skipped for prefers-reduced-motion. */
    if (!this.reduced) node.classList.add(this.dir === 'back' ? 'is-enter-back' : 'is-enter');
    this.dir = null;
    this.root.innerHTML = '';
    this.root.appendChild(node);
    try {
      /* clear the sticky header - the theme publishes its height as --header-height,
         and a fixed 80px offset parked the question title underneath it on mobile */
      var hdr = parseInt(getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height'), 10);
      if (!hdr || isNaN(hdr)) hdr = 96;
      var top = this.root.getBoundingClientRect().top + window.pageYOffset - (hdr + 24);
      if (window.pageYOffset > top + 40) window.scrollTo({ top: top, behavior: 'smooth' });
    } catch (e) {}
  };

  /* ------------------------------------------------------------- boot */
  function boot() {
    var root = document.querySelector('[data-ddi-quiz]');
    if (!root || root.getAttribute('data-ddi-quiz-booted')) return;
    var raw = document.querySelector('[data-ddi-quiz-config]');
    var cfg = {};
    try { cfg = raw ? JSON.parse(raw.textContent) : {}; } catch (e) { cfg = {}; }
    root.setAttribute('data-ddi-quiz-booted', '1');
    var q = new Quiz(root, cfg);
    window.DDI_QUIZ = q;
    q.mount();

    /* The hero's "Start the quiz" button is a plain anchor so it works with no JS.
       With JS we scroll it ourselves, clearing the sticky header the same way
       paint() does - a raw #anchor jump parks question 1 underneath the header. */
    var starters = document.querySelectorAll('[data-ddi-quiz-start]');
    for (var i = 0; i < starters.length; i++) {
      starters[i].addEventListener('click', function (e) {
        e.preventDefault();
        var hdr = parseInt(getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height'), 10);
        if (!hdr || isNaN(hdr)) hdr = 96;
        var top = root.getBoundingClientRect().top + window.pageYOffset - (hdr + 24);
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
  }

  window.DDI_QUIZ_SPEC = SPEC;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
